/* This file is generated by graphql-codegen. Please see README.md for details. */

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** An unsigned 32-bit integer (0 to 4294967295) */
  UnsignedInt: { input: any; output: any; }
};

/** Autogenerated return type of AcceptDpa. */
export type AcceptDpaPayload = {
  user: User;
};

/**
 *  An account is mainly a representation of the users organisation
 *       a user is always part of an account, an account has many users
 */
export type Account = {
  branding: Branding;
  city: Scalars['String']['output'];
  clientNumber?: Maybe<Scalars['Int']['output']>;
  /** The company name */
  company: Scalars['String']['output'];
  country: CountryCode;
  /** ISO 3166-2 code of the country state/province */
  countryState?: Maybe<Scalars['String']['output']>;
  customClientNumber?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  forceOriginalPassword?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  managers: UserConnection;
  otherState?: Maybe<Scalars['String']['output']>;
  /** The parent account, if any */
  parent?: Maybe<Account>;
  passwordMinLength?: Maybe<Scalars['Int']['output']>;
  passwordTtl?: Maybe<Scalars['Int']['output']>;
  phone: Scalars['String']['output'];
  state: AccountState;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};


/**
 *  An account is mainly a representation of the users organisation
 *       a user is always part of an account, an account has many users
 */
export type AccountManagersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

export type AccountFilter = {
  blank?: InputMaybe<AccountFilterBlankOperator>;
  contains?: InputMaybe<AccountFilterContainsOperator>;
  containsNot?: InputMaybe<AccountFilterContainsNotOperator>;
  is?: InputMaybe<AccountFilterIsOperator>;
  isNot?: InputMaybe<AccountFilterIsNotOperator>;
  notBlank?: InputMaybe<AccountFilterNotBlankOperator>;
  withStates?: InputMaybe<AccountFilterWithStatesOperator>;
  withoutStates?: InputMaybe<AccountFilterWithoutStatesOperator>;
};

export enum AccountFilterBlankField {
  City = 'city',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type AccountFilterBlankOperator = {
  field: AccountFilterBlankField;
};

export type AccountFilterContainer = {
  filter?: InputMaybe<AccountFilter>;
  group?: InputMaybe<AccountFilterGroup>;
};

export enum AccountFilterContainsField {
  City = 'city',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export enum AccountFilterContainsNotField {
  City = 'city',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type AccountFilterContainsNotOperator = {
  field: AccountFilterContainsNotField;
  query: Scalars['String']['input'];
};

export type AccountFilterContainsOperator = {
  field: AccountFilterContainsField;
  query: Scalars['String']['input'];
};

/** A group of child filters joined by an operation. */
export type AccountFilterGroup = {
  /** Child filter elements to be joined by the group operation */
  filters?: InputMaybe<Array<AccountFilterContainer>>;
  /** Grouping operator for associated filters */
  operator?: InputMaybe<FilterGroupOperator>;
};

export enum AccountFilterIsField {
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export enum AccountFilterIsNotField {
  City = 'city',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type AccountFilterIsNotOperator = {
  field: AccountFilterIsNotField;
  query: Scalars['String']['input'];
};

export type AccountFilterIsOperator = {
  field: AccountFilterIsField;
  query: Scalars['String']['input'];
};

export enum AccountFilterNotBlankField {
  City = 'city',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type AccountFilterNotBlankOperator = {
  field: AccountFilterNotBlankField;
};

export type AccountFilterWithStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

export type AccountFilterWithoutStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

export type AccountOrderBy = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  key: AccountOrderByKey;
};

export enum AccountOrderByKey {
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Phone = 'phone',
  State = 'state',
  Street = 'street'
}

export enum AccountState {
  /** The account has been activated and is usable */
  Active = 'active',
  /** The account is new and has not yet been activated. */
  New = 'new',
  /** The account has been suspended */
  Suspended = 'suspended'
}

export type AccountType_ValidationResult = Account | ValidationErrors;

/** Features that are available to a logged in user. */
export enum AuthFeature {
  /** Access to managing other accounts. */
  AccountManagement = 'AccountManagement',
  /** Ability to edit reseller branding. */
  BrandingManagement = 'BrandingManagement',
  /** General price visibility. */
  Pricing = 'Pricing',
  /** General ability to access recurring billing functionality, readonly or for management. */
  RecurringBilling = 'RecurringBilling',
  /** Access to management of child accounts and their assets. */
  Reseller = 'Reseller'
}

/**
 * A user's complete authorizations. Useful for checking permissions
 * on the client to avoid unnecessary API traffic.
 *
 */
export type Authorization = {
  /** Access to brand protection services. */
  brandProtectionAccess: Array<BrandProtectionFeature>;
  /** A set of named features describing derived visibility conditions not immediately available from permissions. */
  featureAccess: Array<AuthFeature>;
  isAdmin: Scalars['Boolean']['output'];
  permissions: Array<Permission>;
};

/** Bills which are either invoices or credit notes */
export type Bill = {
  /** Additional references associated with this bill. */
  additionalReferences?: Maybe<Scalars['String']['output']>;
  /** Address associated with the bill. */
  address?: Maybe<Scalars['String']['output']>;
  /** 1st line of address associated with the bill. */
  address1?: Maybe<Scalars['String']['output']>;
  /** 2nd line of address associated with the bill. */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of the associated address. */
  city?: Maybe<Scalars['String']['output']>;
  /** Whether this bill is issued in the name of a client. */
  clientBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Company name billing contact. */
  company?: Maybe<Scalars['String']['output']>;
  /** Contact name for the bill. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** ISO country code of the associated address. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Country name of the associated address. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** State within the associated country. */
  countryState?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency in which the bill is denominated. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was downloaded. */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email associated with the bill. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the bill. */
  id: Scalars['ID']['output'];
  /** Date when the bill was issued. */
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The bill will not be issued automatiaclly when this is set. */
  keepOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Invoice number of the bill. */
  number?: Maybe<Scalars['String']['output']>;
  /** The account this bill belongs to. */
  owner?: Maybe<Account>;
  /** End date of the billing period. */
  periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start date of the billing period. */
  periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The purchase order of the bill. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The recipient of the bill. */
  recipient?: Maybe<Recipient>;
  /** Type of the bill's recipient. */
  recipientType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was sent by email. */
  sentByEmail?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when the bill was sent by post. */
  sentByPost?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status of the bill. */
  state?: Maybe<BillState>;
  /** Total net amount of the bill. */
  totalNetAmount?: Maybe<Scalars['Float']['output']>;
  /** Total tax amount in the bill. */
  totalTaxAmount?: Maybe<Scalars['Float']['output']>;
  /** The type of the bill, either Billing::Invoice or Billing::CreditNote. */
  type?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** VAT ID for the bill. */
  vatId?: Maybe<Scalars['String']['output']>;
  /** Postal code of the associated address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Bill. */
export type BillConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BillEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Bill>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Bill>;
};

export enum BillState {
  /** The bill was canceled */
  Canceled = 'canceled',
  /** The bill has been credited, only used for invoices */
  Credited = 'credited',
  /** The bill is issued, only used for credit notes */
  Issued = 'issued',
  /** The bill is a preliminary one */
  New = 'new',
  /** The bill was overpaid, only used for invoices */
  Overpaid = 'overpaid',
  /** The bill is paid, only used for invoices */
  Paid = 'paid',
  /** The bill has been partially credited, only used for invoices */
  PartiallyCredited = 'partially_credited',
  /** The bill is underpaid, only used for invoices */
  Underpaid = 'underpaid',
  /** The bill is unpaid, only used for invoices */
  Unpaid = 'unpaid'
}

/** A brand which can have domains and other objects assigned to it. */
export type Brand = {
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Divisions assigned to this brand */
  departments: Array<Department>;
  id: Scalars['ID']['output'];
  /** The name of the brand */
  name: Scalars['String']['output'];
  trademarks: TrademarkConnection;
  trademarksCount: Scalars['Int']['output'];
  /** Timestamp of last update */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A brand which can have domains and other objects assigned to it. */
export type BrandTrademarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Access to brand protection ("monitoring") features. */
export enum BrandProtectionFeature {
  /** Content monitoring */
  BrandMonitoringContentMonitoring = 'BrandMonitoring_ContentMonitoring',
  /** Domain audit */
  BrandMonitoringDomainAudit = 'BrandMonitoring_DomainAudit',
  /** Domain monitoring */
  BrandMonitoringDomainMonitoring = 'BrandMonitoring_DomainMonitoring',
  /** Logo monitoring */
  BrandMonitoringLogoMonitoring = 'BrandMonitoring_LogoMonitoring',
  /** Registrant search/monitoring */
  BrandMonitoringRegistrantSearch = 'BrandMonitoring_RegistrantSearch',
  /** Social media */
  BrandMonitoringSocialMediaMonitoring = 'BrandMonitoring_SocialMediaMonitoring',
  /** Web page and Whois monitoring */
  BrandMonitoringWebPageAndWhoisMonitoring = 'BrandMonitoring_WebPageAndWhoisMonitoring',
  /** Specific access to the "brand protection" sections of brand monitoring. */
  BrandProtectionGroup = 'BrandProtectionGroup',
  /** Consultation */
  Consultation = 'Consultation',
  /** Whois disclosure/verification */
  DisclosureWhois = 'DisclosureWhois',
  /** Domain brokerage */
  DomainBrokerage = 'DomainBrokerage',
  /** Specific access to the "domain names" sections of brand monitoring. */
  DomainNamesGroup = 'DomainNamesGroup',
  /** Specific access to the "enforcement" sections of brand monitoring. */
  EnforcementGroup = 'EnforcementGroup',
  /** Specific access to the "content monitoring" sections of brand monitoring. */
  InternetGroup = 'InternetGroup',
  /** Domain acquisition */
  PurchaseDomain = 'PurchaseDomain',
  /** Domain recovery */
  RecoverDomain = 'RecoverDomain',
  /** Dispute resolution */
  ResolveDispute = 'ResolveDispute',
  /** Specific access to the "secondary market" sections of brand monitoring. */
  SecondMarketGroup = 'SecondMarketGroup',
  /** Backorder */
  Snapback = 'Snapback',
  /** Takedown */
  Takedown = 'Takedown'
}

/** Branding object revealing the branding details associated with a specific domain or application */
export type Branding = {
  /** Associated color theme for the Branding object */
  colorTheme?: Maybe<ColorTheme>;
  /** The host that this branding configuration gets applied to */
  host?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the Branding object */
  id: Scalars['ID']['output'];
  /** Information links, e.g., legal, to be shown in the UI. */
  infoLinks: Array<TranslatedInfoLinks>;
  /** The name of the Branding object */
  name?: Maybe<Scalars['String']['output']>;
  /** The title shown in browser tabs */
  pageTitle: Scalars['String']['output'];
};

export type Cart = {
  size: Scalars['Int']['output'];
};

export type CheckDomainAvailabilityResult = {
  domainName: Scalars['String']['output'];
  state: CheckDomainAvailabilityState;
};

export enum CheckDomainAvailabilityState {
  /** The name is available but must be registered through an application process. */
  Application = 'application',
  Available = 'available',
  /** The name is on the collision list, and while it might never be delegated, it can actually be ordered. */
  Collision = 'collision',
  /** At this time only non-binding expressions of interest are supported. */
  EoiOnly = 'eoi_only',
  /** Something went wrong during the lookup. */
  Error = 'error',
  Inactive = 'inactive',
  /** Invalid domain name. */
  Invalid = 'invalid',
  Owned = 'owned',
  Premium = 'premium',
  /** Part of a post-launch release programme and eligible for domain applications. */
  Release = 'release',
  Reserved = 'reserved',
  Taken = 'taken',
  /** Some handlers rely on DNS for the checks. We do not consider those results as authoritative if they report a domain as taken. */
  Uncertain = 'uncertain'
}

export type ColorTheme = {
  /** Accent color theme attribute. */
  accent?: Maybe<Scalars['String']['output']>;
  /** Body Background color theme attribute. */
  bodyBackground?: Maybe<Scalars['String']['output']>;
  /** Body Background 2 color theme attribute. */
  bodyBackground2?: Maybe<Scalars['String']['output']>;
  /** Body Background Dark color theme attribute. */
  bodyBackgroundDark?: Maybe<Scalars['String']['output']>;
  /** Button Background color theme attribute. */
  buttonBackground?: Maybe<Scalars['String']['output']>;
  /** Button Background Active color theme attribute. */
  buttonBackgroundActive?: Maybe<Scalars['String']['output']>;
  /** Button Background Hover color theme attribute. */
  buttonBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Button Text color theme attribute. */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Button Text Active color theme attribute. */
  buttonTextActive?: Maybe<Scalars['String']['output']>;
  /** Correct color theme attribute. */
  correct?: Maybe<Scalars['String']['output']>;
  /** Divisions Search Box color theme attribute. */
  divisionsSearchBox?: Maybe<Scalars['String']['output']>;
  /** Filter Background color theme attribute. */
  filterBackground?: Maybe<Scalars['String']['output']>;
  /** Filter Text color theme attribute. */
  filterText?: Maybe<Scalars['String']['output']>;
  /** Flexbox color theme attribute. */
  flexbox?: Maybe<Scalars['String']['output']>;
  /** Flexbox Background color theme attribute. */
  flexboxBackground?: Maybe<Scalars['String']['output']>;
  /** Flexbox Border Bottom color theme attribute. */
  flexboxBorderBottom?: Maybe<Scalars['String']['output']>;
  /** Flexbox Match color theme attribute. */
  flexboxMatch?: Maybe<Scalars['String']['output']>;
  /** Flexbox Match Background color theme attribute. */
  flexboxMatchBackground?: Maybe<Scalars['String']['output']>;
  /** Footer Border Right color theme attribute. */
  footerBorderRight?: Maybe<Scalars['String']['output']>;
  /** Footer Copyright color theme attribute. */
  footerCopyright?: Maybe<Scalars['String']['output']>;
  /** Footer Link color theme attribute. */
  footerLink?: Maybe<Scalars['String']['output']>;
  /** Footer Link Background color theme attribute. */
  footerLinkBackground?: Maybe<Scalars['String']['output']>;
  /** Form Background Active color theme attribute. */
  formBackgroundActive?: Maybe<Scalars['String']['output']>;
  /** Form Help color theme attribute. */
  formHelp?: Maybe<Scalars['String']['output']>;
  /** Form Input Background color theme attribute. */
  formInputBackground?: Maybe<Scalars['String']['output']>;
  /** Form Input Border color theme attribute. */
  formInputBorder?: Maybe<Scalars['String']['output']>;
  /** Form Input Color color theme attribute. */
  formInputColor?: Maybe<Scalars['String']['output']>;
  /** Form Input Submit Background color theme attribute. */
  formInputSubmitBackground?: Maybe<Scalars['String']['output']>;
  /** Form Input Submit Background Hover color theme attribute. */
  formInputSubmitBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Form Input Submit Color color theme attribute. */
  formInputSubmitColor?: Maybe<Scalars['String']['output']>;
  /** Form Input Symbol color theme attribute. */
  formInputSymbol?: Maybe<Scalars['String']['output']>;
  /** Form Label Color color theme attribute. */
  formLabelColor?: Maybe<Scalars['String']['output']>;
  /** Form Label Required color theme attribute. */
  formLabelRequired?: Maybe<Scalars['String']['output']>;
  /** Form Link Color color theme attribute. */
  formLinkColor?: Maybe<Scalars['String']['output']>;
  /** Form Readonly color theme attribute. */
  formReadonly?: Maybe<Scalars['String']['output']>;
  /** Form Readonly Background color theme attribute. */
  formReadonlyBackground?: Maybe<Scalars['String']['output']>;
  /** Form Select Background Even color theme attribute. */
  formSelectBackgroundEven?: Maybe<Scalars['String']['output']>;
  /** Form Select Background Highlighted color theme attribute. */
  formSelectBackgroundHighlighted?: Maybe<Scalars['String']['output']>;
  /** Form Select Background Odd color theme attribute. */
  formSelectBackgroundOdd?: Maybe<Scalars['String']['output']>;
  /** Form Select Text Highlighted color theme attribute. */
  formSelectTextHighlighted?: Maybe<Scalars['String']['output']>;
  /** Grid Cell Border Right color theme attribute. */
  gridCellBorderRight?: Maybe<Scalars['String']['output']>;
  /** Grid Group Background color theme attribute. */
  gridGroupBackground?: Maybe<Scalars['String']['output']>;
  /** Grid Group Background Hover color theme attribute. */
  gridGroupBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Grid Group Count color theme attribute. */
  gridGroupCount?: Maybe<Scalars['String']['output']>;
  /** Grid Group Text color theme attribute. */
  gridGroupText?: Maybe<Scalars['String']['output']>;
  /** Grid Group Text Hover color theme attribute. */
  gridGroupTextHover?: Maybe<Scalars['String']['output']>;
  /** Grid Header Background color theme attribute. */
  gridHeaderBackground?: Maybe<Scalars['String']['output']>;
  /** Grid Header Background Hover color theme attribute. */
  gridHeaderBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Grid Header Background Sorted color theme attribute. */
  gridHeaderBackgroundSorted?: Maybe<Scalars['String']['output']>;
  /** Grid Header Border Right color theme attribute. */
  gridHeaderBorderRight?: Maybe<Scalars['String']['output']>;
  /** Grid Header Box Shadow Sorted color theme attribute. */
  gridHeaderBoxShadowSorted?: Maybe<Scalars['String']['output']>;
  /** Grid Header Text color theme attribute. */
  gridHeaderText?: Maybe<Scalars['String']['output']>;
  /** Grid Load More Background color theme attribute. */
  gridLoadMoreBackground?: Maybe<Scalars['String']['output']>;
  /** Grid Load More Text color theme attribute. */
  gridLoadMoreText?: Maybe<Scalars['String']['output']>;
  /** Grid Negative Money Amount color theme attribute. */
  gridNegativeMoneyAmount?: Maybe<Scalars['String']['output']>;
  /** Grid Row Background Even color theme attribute. */
  gridRowBackgroundEven?: Maybe<Scalars['String']['output']>;
  /** Grid Row Background Hover color theme attribute. */
  gridRowBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Grid Row Background Odd color theme attribute. */
  gridRowBackgroundOdd?: Maybe<Scalars['String']['output']>;
  /** Grid Row Border Bottom Even color theme attribute. */
  gridRowBorderBottomEven?: Maybe<Scalars['String']['output']>;
  /** Grid Row Border Bottom Odd color theme attribute. */
  gridRowBorderBottomOdd?: Maybe<Scalars['String']['output']>;
  /** Grid Row Border Top Even color theme attribute. */
  gridRowBorderTopEven?: Maybe<Scalars['String']['output']>;
  /** Grid Row Border Top Odd color theme attribute. */
  gridRowBorderTopOdd?: Maybe<Scalars['String']['output']>;
  /** Grid Row Text color theme attribute. */
  gridRowText?: Maybe<Scalars['String']['output']>;
  /** Grid Row Text Hover color theme attribute. */
  gridRowTextHover?: Maybe<Scalars['String']['output']>;
  /** Grid Selection color theme attribute. */
  gridSelection?: Maybe<Scalars['String']['output']>;
  /** Grid Selection Background color theme attribute. */
  gridSelectionBackground?: Maybe<Scalars['String']['output']>;
  /** Header Background color theme attribute. */
  headerBackground?: Maybe<Scalars['String']['output']>;
  /** Hovermenu Background color theme attribute. */
  hovermenuBackground?: Maybe<Scalars['String']['output']>;
  /** Hovermenu Background Bottom color theme attribute. */
  hovermenuBackgroundBottom?: Maybe<Scalars['String']['output']>;
  /** Hovermenu Background Selected color theme attribute. */
  hovermenuBackgroundSelected?: Maybe<Scalars['String']['output']>;
  /** Hovermenu Background Subuser color theme attribute. */
  hovermenuBackgroundSubuser?: Maybe<Scalars['String']['output']>;
  /** Hovermenu Selected color theme attribute. */
  hovermenuSelected?: Maybe<Scalars['String']['output']>;
  /** Incorrect color theme attribute. */
  incorrect?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Background Error color theme attribute. */
  jgrowlBackgroundError?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Background Success color theme attribute. */
  jgrowlBackgroundSuccess?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Background Warning color theme attribute. */
  jgrowlBackgroundWarning?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Border Error color theme attribute. */
  jgrowlBorderError?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Border Success color theme attribute. */
  jgrowlBorderSuccess?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Border Warning color theme attribute. */
  jgrowlBorderWarning?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Text Error color theme attribute. */
  jgrowlTextError?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Text Success color theme attribute. */
  jgrowlTextSuccess?: Maybe<Scalars['String']['output']>;
  /** Jgrowl Text Warning color theme attribute. */
  jgrowlTextWarning?: Maybe<Scalars['String']['output']>;
  /** Login Form Background color theme attribute. */
  loginFormBackground?: Maybe<Scalars['String']['output']>;
  /** Login Form Box Shadow color theme attribute. */
  loginFormBoxShadow?: Maybe<Scalars['String']['output']>;
  /** Login Form Password Forgotten Link color theme attribute. */
  loginFormPasswordForgottenLink?: Maybe<Scalars['String']['output']>;
  /** Login Header Background color theme attribute. */
  loginHeaderBackground?: Maybe<Scalars['String']['output']>;
  /** Login Header Link color theme attribute. */
  loginHeaderLink?: Maybe<Scalars['String']['output']>;
  /** Navigation Background 1 color theme attribute. */
  navigationBackground1?: Maybe<Scalars['String']['output']>;
  /** Navigation Background 2 color theme attribute. */
  navigationBackground2?: Maybe<Scalars['String']['output']>;
  /** Navigation Bar color theme attribute. */
  navigationBar?: Maybe<Scalars['String']['output']>;
  /** Navigation Border Active color theme attribute. */
  navigationBorderActive?: Maybe<Scalars['String']['output']>;
  /** Navigation Link color theme attribute. */
  navigationLink?: Maybe<Scalars['String']['output']>;
  /** Navigation Link Background Hover color theme attribute. */
  navigationLinkBackgroundHover?: Maybe<Scalars['String']['output']>;
  /** Navigation Link Hover color theme attribute. */
  navigationLinkHover?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Bottom color theme attribute. */
  navigationMainMenuBottom?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Header color theme attribute. */
  navigationMainMenuHeader?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Icon color theme attribute. */
  navigationMainMenuIcon?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Icon Active color theme attribute. */
  navigationMainMenuIconActive?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Title color theme attribute. */
  navigationMainMenuTitle?: Maybe<Scalars['String']['output']>;
  /** Navigation Main Menu Title Active color theme attribute. */
  navigationMainMenuTitleActive?: Maybe<Scalars['String']['output']>;
  /** Navigation Text Active color theme attribute. */
  navigationTextActive?: Maybe<Scalars['String']['output']>;
  /** Page Title color theme attribute. */
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** Page Title Shadow Bottom color theme attribute. */
  pageTitleShadowBottom?: Maybe<Scalars['String']['output']>;
  /** Secondary Navigation Background Active color theme attribute. */
  secondaryNavigationBackgroundActive?: Maybe<Scalars['String']['output']>;
  /** Secondary Navigation Hovermenu Background color theme attribute. */
  secondaryNavigationHovermenuBackground?: Maybe<Scalars['String']['output']>;
  /** Secondary Navigation Text Color color theme attribute. */
  secondaryNavigationTextColor?: Maybe<Scalars['String']['output']>;
  /** Secondary Navigation Text Color Active color theme attribute. */
  secondaryNavigationTextColorActive?: Maybe<Scalars['String']['output']>;
  /** Tab Background color theme attribute. */
  tabBackground?: Maybe<Scalars['String']['output']>;
  /** Tab Background Accent color theme attribute. */
  tabBackgroundAccent?: Maybe<Scalars['String']['output']>;
  /** Tab Text color theme attribute. */
  tabText?: Maybe<Scalars['String']['output']>;
  /** Table Border color theme attribute. */
  tableBorder?: Maybe<Scalars['String']['output']>;
  /** Toolbar Accent color theme attribute. */
  toolbarAccent?: Maybe<Scalars['String']['output']>;
  /** Toolbar Background color theme attribute. */
  toolbarBackground?: Maybe<Scalars['String']['output']>;
  /** Toolbar Background 2 color theme attribute. */
  toolbarBackground2?: Maybe<Scalars['String']['output']>;
  /** Toolbar Background Selected color theme attribute. */
  toolbarBackgroundSelected?: Maybe<Scalars['String']['output']>;
  /** Toolbar Border Bottom color theme attribute. */
  toolbarBorderBottom?: Maybe<Scalars['String']['output']>;
  /** Toolbar Border Right color theme attribute. */
  toolbarBorderRight?: Maybe<Scalars['String']['output']>;
  /** Toolbar Border Top color theme attribute. */
  toolbarBorderTop?: Maybe<Scalars['String']['output']>;
  /** Toolbar Hover color theme attribute. */
  toolbarHover?: Maybe<Scalars['String']['output']>;
  /** Toolbar Hover Background color theme attribute. */
  toolbarHoverBackground?: Maybe<Scalars['String']['output']>;
  /** Toolbar Text Active color theme attribute. */
  toolbarTextActive?: Maybe<Scalars['String']['output']>;
  /** Toolbar Text Inactive color theme attribute. */
  toolbarTextInactive?: Maybe<Scalars['String']['output']>;
  /** Waiting Overlay Background color theme attribute. */
  waitingOverlayBackground?: Maybe<Scalars['String']['output']>;
  /** Waiting Overlay Message Background color theme attribute. */
  waitingOverlayMessageBackground?: Maybe<Scalars['String']['output']>;
  /** Widget 1 color theme attribute. */
  widget1?: Maybe<Scalars['String']['output']>;
  /** Widget 2 color theme attribute. */
  widget2?: Maybe<Scalars['String']['output']>;
  /** Widget 3 color theme attribute. */
  widget3?: Maybe<Scalars['String']['output']>;
  /** Widget 4 color theme attribute. */
  widget4?: Maybe<Scalars['String']['output']>;
  /** Widget 5 color theme attribute. */
  widget5?: Maybe<Scalars['String']['output']>;
  /** Widget 6 color theme attribute. */
  widget6?: Maybe<Scalars['String']['output']>;
  /** Widget 7 color theme attribute. */
  widget7?: Maybe<Scalars['String']['output']>;
  /** Widget 8 color theme attribute. */
  widget8?: Maybe<Scalars['String']['output']>;
  /** Widget 9 color theme attribute. */
  widget9?: Maybe<Scalars['String']['output']>;
  /** Widget 10 color theme attribute. */
  widget10?: Maybe<Scalars['String']['output']>;
  /** Widget 11 color theme attribute. */
  widget11?: Maybe<Scalars['String']['output']>;
  /** Widget 12 color theme attribute. */
  widget12?: Maybe<Scalars['String']['output']>;
  /** Widget Badge Gray color theme attribute. */
  widgetBadgeGray?: Maybe<Scalars['String']['output']>;
  /** Widget Footer Border color theme attribute. */
  widgetFooterBorder?: Maybe<Scalars['String']['output']>;
  /** Widget Header Background color theme attribute. */
  widgetHeaderBackground?: Maybe<Scalars['String']['output']>;
  /** Widget Link color theme attribute. */
  widgetLink?: Maybe<Scalars['String']['output']>;
  /** Widget Odd Row Background color theme attribute. */
  widgetOddRowBackground?: Maybe<Scalars['String']['output']>;
  /** Widget Text color theme attribute. */
  widgetText?: Maybe<Scalars['String']['output']>;
  /** Widget Timestamps color theme attribute. */
  widgetTimestamps?: Maybe<Scalars['String']['output']>;
  /** Widget Whois Button color theme attribute. */
  widgetWhoisButton?: Maybe<Scalars['String']['output']>;
  /** Widget Whois Button Hover color theme attribute. */
  widgetWhoisButtonHover?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  adminContactDomains: DomainConnection;
  billingContactDomains: DomainConnection;
  /** Birthday */
  birthday?: Maybe<Scalars['ISO8601Date']['output']>;
  /** An optional brand assigend to this contact */
  brand?: Maybe<Brand>;
  city: Scalars['String']['output'];
  /** Commercial registration number */
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 code */
  country: CountryCode;
  /** Principal subdivision ISO code */
  countrySubdivisionCode?: Maybe<Scalars['String']['output']>;
  /** Principal subdivision name, e.g. province or state */
  countrySubdivisionName?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email address */
  email: Scalars['String']['output'];
  /** Fax number */
  fax?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  /** A unique identifier */
  handle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ID card number */
  idCardNumber?: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isBilling: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  isTech: Scalars['Boolean']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  ownerContactDomains: DomainConnection;
  /** Phone number */
  phone: Scalars['String']['output'];
  /** The street address consists of three lines1 */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** Company tax number */
  taxNumberCompany?: Maybe<Scalars['String']['output']>;
  /** Personal tax number */
  taxNumberPersonal?: Maybe<Scalars['String']['output']>;
  techContactDomains: DomainConnection;
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp of last update */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verified: Scalars['Boolean']['output'];
  zip: Scalars['String']['output'];
};


export type ContactAdminContactDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactBillingContactDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactOwnerContactDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactTechContactDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactPerson = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** ISO 3166-1 alpha-2 codes */
export enum CountryCode {
  /** Ascension Island */
  Ac = 'AC',
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Netherlands Antilles */
  An = 'AN',
  /** Angola */
  Ao = 'AO',
  /** African Regional Industrial Property Organization */
  Ap = 'AP',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Caribbean Netherlands */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Benelux Trademarks and Design Offices */
  Bx = 'BX',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo (DRC) */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo (Republic) */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Ivory Coast */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Clipperton Island */
  Cp = 'CP',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cape Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Diego Garcia */
  Dg = 'DG',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ceuta and Melilla */
  Ea = 'EA',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Union of Countries under the European Community Patent Convention */
  Ef = 'EF',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** European Trademark Office */
  Em = 'EM',
  /** European Patent Organization (Union of countries under the European Patent Convention) */
  Ep = 'EP',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** European Union */
  Eu = 'EU',
  /** Eurasian Patent Organization */
  Ev = 'EV',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Islas Malvinas) */
  Fk = 'FK',
  /** Micronesia */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Patent Office of the Cooperation Council for the Arab States of the Gulf (GCC) */
  Gc = 'GC',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia & South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard & McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** International Bureau of WIPO */
  Ib = 'IB',
  /** Canary Islands */
  Ic = 'IC',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia (FYROM) */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar (Burma) */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macau */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** African Intellectual Property Organization */
  Oa = 'OA',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn Islands */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Outlying Oceania */
  Qo = 'QO',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russia */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** São Tomé and Príncipe */
  St = 'ST',
  /** Soviet Union */
  Su = 'SU',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten */
  Sx = 'SX',
  /** Syria */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Tristan da Cunha */
  Ta = 'TA',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** East Timor */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** U.S. Outlying Islands */
  Um = 'UM',
  /** U.S. */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Vatican City */
  Va = 'VA',
  /** St. Vincent & Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** British Virgin Islands */
  Vg = 'VG',
  /** U.S. Virgin Islands */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** World Intellectual Property Organization */
  Wo = 'WO',
  /** Samoa */
  Ws = 'WS',
  /** Kosovo */
  Xk = 'XK',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW',
  /** Unknown Region */
  Zz = 'ZZ'
}

export type CountryState = {
  /** ISO 3166-2 code of the country subdivision */
  isoCode: Scalars['String']['output'];
  /** Name of the country subdivision */
  name: Scalars['String']['output'];
};

export type CreateUserAttributes = {
  accountId: Scalars['ID']['input'];
  allowedIpAddresses?: InputMaybe<Scalars['String']['input']>;
  answer: Scalars['String']['input'];
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  commercialRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryState: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  idCardNumber?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastname: Scalars['String']['input'];
  login: Scalars['String']['input'];
  /** State or province if the country subdivision is not in ISO 3166-2 */
  otherState?: InputMaybe<Scalars['String']['input']>;
  passphrase: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  street: Scalars['String']['input'];
  taxNumberCompany?: InputMaybe<Scalars['String']['input']>;
  taxNumberPersonal?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/** Represents a credit note for an invoice in the billing system. */
export type Credit = Bill & {
  /** Additional references associated with this bill. */
  additionalReferences?: Maybe<Scalars['String']['output']>;
  /** Address associated with the bill. */
  address?: Maybe<Scalars['String']['output']>;
  /** 1st line of address associated with the bill. */
  address1?: Maybe<Scalars['String']['output']>;
  /** 2nd line of address associated with the bill. */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of the associated address. */
  city?: Maybe<Scalars['String']['output']>;
  /** Whether this bill is issued in the name of a client. */
  clientBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Company name billing contact. */
  company?: Maybe<Scalars['String']['output']>;
  /** Contact name for the bill. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** ISO country code of the associated address. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Country name of the associated address. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** State within the associated country. */
  countryState?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency in which the bill is denominated. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was downloaded. */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email associated with the bill. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the bill. */
  id: Scalars['ID']['output'];
  /** The invoice associated with this credit. */
  invoice: Invoice;
  /** Date when the bill was issued. */
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The bill will not be issued automatiaclly when this is set. */
  keepOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Invoice number of the bill. */
  number?: Maybe<Scalars['String']['output']>;
  /** The account this bill belongs to. */
  owner?: Maybe<Account>;
  /** End date of the billing period. */
  periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start date of the billing period. */
  periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The purchase order of the bill. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The recipient of the bill. */
  recipient?: Maybe<Recipient>;
  /** Type of the bill's recipient. */
  recipientType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was sent by email. */
  sentByEmail?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when the bill was sent by post. */
  sentByPost?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status of the bill. */
  state?: Maybe<BillState>;
  /** Total net amount of the bill. */
  totalNetAmount?: Maybe<Scalars['Float']['output']>;
  /** Total tax amount in the bill. */
  totalTaxAmount?: Maybe<Scalars['Float']['output']>;
  /** The type of the bill, either Billing::Invoice or Billing::CreditNote. */
  type?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** VAT ID for the bill. */
  vatId?: Maybe<Scalars['String']['output']>;
  /** Postal code of the associated address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** ISO 4217 currency code. */
export enum Currency {
  Aed = 'AED',
  Aud = 'AUD',
  Bgn = 'BGN',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Hrk = 'HRK',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nok = 'NOK',
  Nzd = 'NZD',
  Php = 'PHP',
  Pln = 'PLN',
  Qar = 'QAR',
  Ron = 'RON',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Usd = 'USD',
  Zar = 'ZAR'
}

/** Autogenerated return type of DeleteDnsRecord. */
export type DeleteDnsRecordPayload = {
  /** IDs of the deleted records. */
  ids: Array<Scalars['ID']['output']>;
};

/** Autogenerated return type of DeleteDnsRecords. */
export type DeleteDnsRecordsPayload = {
  /** IDs of the deleted records. */
  ids: Array<Scalars['ID']['output']>;
};

/** Autogenerated return type of DeleteDnsZone. */
export type DeleteDnsZonePayload = {
  domainName?: Maybe<Scalars['String']['output']>;
};

/** A division which can be used to partition your portfolio. */
export type Department = {
  /** The owning account */
  account: Account;
  id: Scalars['ID']['output'];
  /** Name of the division */
  name: Scalars['String']['output'];
};

export type DnsKey = {
  /** DNS security algorithm number */
  algorithm: Scalars['Int']['output'];
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** If enabled, the key is considered as a candidate for publication. If this flag is set to `false`, no further attempts to publish it to registries will be made, even though a remote DNS provider keeps signing with it. */
  enabled: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Flags */
  flags?: Maybe<Scalars['Int']['output']>;
  /** ID of the DNS key */
  id: Scalars['ID']['output'];
  /** Key tag */
  keyTag?: Maybe<Scalars['Int']['output']>;
  overlap?: Maybe<Scalars['String']['output']>;
  /** Public key */
  publicKey?: Maybe<Scalars['String']['output']>;
  /** If true, the key is being used by the registry to sign the delegation, i.e., the parent zone serves DS records matching the key. */
  seenDs: Scalars['Boolean']['output'];
  /** If true, the key is used for zone signing by the DNS provider. */
  signing: Scalars['Boolean']['output'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validAfter?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validity?: Maybe<Scalars['String']['output']>;
};

/**
 *               Interface for interpreting DnsRecords and all of the sub-types.
 *
 *               	  {
 *               	    dnsRecords {
 *               	      __typename
 *               	        ... on DnsRecord_MX {
 *               	          priority
 *               	          exchange
 *               	        }
 *               	        ... on DnsRecord_CAA {
 *               	          flags
 *               	          tag
 *               	          value
 *               	        }
 *               	    id,
 *               	    (etc...)
 *               	    }
 *               	  }
 *
 */
export type DnsRecord = {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** Attributes for creating and updating DNS records */
export type DnsRecordAttributes = {
  /** The dns_zone must be identified by ID.  Needs to be present for creation and absent for record updates.  If included with updates it will be ignored. */
  dnsZoneId?: InputMaybe<Scalars['ID']['input']>;
  /** The host of the DnsRecord.  This can be blank. */
  host?: InputMaybe<Scalars['String']['input']>;
  /** ID needs to be present for updates and absent for record creation.  If included with creation it will be ignored. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Rdata and Type are both essential elements when creating a DnsRecord.  The type will determine how rdata is parsed and will directly impact your DnsRecord.  This is a required argument. */
  rdata: Scalars['String']['input'];
  /** This field can be left blank and whatever the default for your DnsRecord type is will be filled in. */
  ttl?: InputMaybe<Scalars['Int']['input']>;
  /** Only specify type when creating records.  This will impact how rdata is parsed.  Example: "MX", "A", "CAA", "TXT" */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Basic DNS Record.  This type should never be created. */
export type DnsRecordBase = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** CAA (Certification Authority Authorization) resource record */
export type DnsRecordCaa = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  flags: Scalars['Int']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** MX (mail exchanger) resource record */
export type DnsRecordMx = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  exchange: Scalars['String']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  priority: Scalars['Int']['output'];
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** NAPTR (Naming Authority Pointer) resource record */
export type DnsRecordNaptr = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  flags: Scalars['String']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  order: Scalars['Int']['output'];
  preference: Scalars['Int']['output'];
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  regexp: Scalars['String']['output'];
  replacement: Scalars['String']['output'];
  service: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** SOA (start of authority) resource record */
export type DnsRecordSoa = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  expire: Scalars['Int']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  minTtl: Scalars['Int']['output'];
  notes: Array<Note>;
  primary: Scalars['String']['output'];
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  refresh: Scalars['Int']['output'];
  serial: Scalars['Int']['output'];
  slaveRetry: Scalars['Int']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** SRV (service) resource record */
export type DnsRecordSrv = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  port: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  target: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

/** Basic DNS Record.  This type should never be created. */
export type DnsRecordSshfp = DnsRecord & {
  algorithm: Scalars['Int']['output'];
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fingerprint: Scalars['String']['output'];
  fingerprintType: Scalars['Int']['output'];
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** X-MAIL-FWD (email forwarding) resource record. This is a custom record type used to support email forwardings. The DNS zone will only contain implicit MX records that point to the mail forwarding servers. This record captures additional data that is not present in the MX records alone. */
export type DnsRecordXmailfwd = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  recipient: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** X-WEB-FWD (web forwarding) resource record. This is a custom record type used to support web forwardings. The DNS zone will only contain implicit A/AAAA records that point to the web forwarding servers. This record captures additional data that is not present in the A/AAAA records alone. */
export type DnsRecordXwebfwd = DnsRecord & {
  /** Master zonefile representation of the record. */
  bindSyntax?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<ContactPerson>;
  errors?: Maybe<Scalars['JSON']['output']>;
  forwardType: WebForwardTypes;
  fqdn?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** The ID can be null for records that are not persisted during creation. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Locked records cannot (directly) be modified by users; those can be apex nameservers or records created by forwardings. */
  locked: Scalars['Boolean']['output'];
  notes: Array<Note>;
  /** String representation of all record data. Use type-specific interfaces where available. */
  rdata: Scalars['String']['output'];
  target: Scalars['String']['output'];
  ttl?: Maybe<Scalars['Int']['output']>;
  /** Resource record type, e.g., "A", "MX", … */
  type: Scalars['String']['output'];
};

/** Object for filtering dns records */
export type DnsRecordsFilters = {
  /** Filter for DNS record types. Example: ["MX", "A", "CAA", "TXT"] */
  recordTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DnsZone = {
  /** DNS keys for zones which have DNSSEC enabled */
  dnsKeys: Array<DnsKey>;
  /** The ID of the DNS zone */
  id: Scalars['ID']['output'];
  /** Domain name */
  name: Scalars['String']['output'];
  /** "primary" or "secondary", depending on the zone. */
  zoneType: Scalars['String']['output'];
};

/** The connection type for DnsZone. */
export type DnsZoneConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DnsZoneEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DnsZone>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DnsZoneDiff = {
  add: Array<DnsRecord>;
  keep: Array<DnsRecord>;
  remove: Array<DnsRecord>;
};

/** An edge in a connection. */
export type DnsZoneEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DnsZone>;
};

export type DnsZonePrimary = DnsZone & {
  /** DNS keys for zones which have DNSSEC enabled */
  dnsKeys: Array<DnsKey>;
  dnsRecords?: Maybe<Array<DnsRecord>>;
  /** The ID of the DNS zone */
  id: Scalars['ID']['output'];
  lastPublishedSerial?: Maybe<Scalars['UnsignedInt']['output']>;
  /** Domain name */
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** "primary" or "secondary", depending on the zone. */
  zoneType: Scalars['String']['output'];
};

export type DnsZoneSecondary = DnsZone & {
  /** DNS keys for zones which have DNSSEC enabled */
  dnsKeys: Array<DnsKey>;
  /** The ID of the DNS zone */
  id: Scalars['ID']['output'];
  masters: Array<Scalars['String']['output']>;
  /** Domain name */
  name: Scalars['String']['output'];
  /** "primary" or "secondary", depending on the zone. */
  zoneType: Scalars['String']['output'];
};

/** Domain object */
export type Domain = {
  /** The owning account */
  account: Account;
  /** Administrative contact */
  adminContact?: Maybe<Contact>;
  basename: Scalars['String']['output'];
  /** Billing contact */
  billingContact?: Maybe<Contact>;
  /** Assigned brand */
  brand?: Maybe<Brand>;
  clientManaged: Scalars['Boolean']['output'];
  costUnit?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  deleteLock: Scalars['Boolean']['output'];
  /** Assigned division */
  department?: Maybe<Department>;
  dnsZone?: Maybe<DnsZone>;
  /** Assigned domain group */
  domainGroup?: Maybe<DomainGroup>;
  /** Expiration timestamp */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Internationalized domain name (IDN) */
  idn: Scalars['String']['output'];
  /** Domain name in punycode representation */
  name: Scalars['String']['output'];
  nameserverSet?: Maybe<NameserverSet>;
  nameservers?: Maybe<NameserverConnection>;
  notes?: Maybe<NoteConnection>;
  owner: Account;
  /** Owner contact */
  ownerContact?: Maybe<Contact>;
  premium: Scalars['Boolean']['output'];
  /** Registration timestamp */
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  renewalMode?: Maybe<Scalars['String']['output']>;
  socialMediaAccounts?: Maybe<SocialMediaAccountConnection>;
  /** Current status of the domain */
  state: DomainState;
  supportsAuthcode: Scalars['Boolean']['output'];
  /** Technical contact */
  techContact?: Maybe<Contact>;
  thumbnail: Scalars['String']['output'];
  /** The domain's top-level domain (TLD) */
  tld: Tld;
  trademarks: TrademarkConnection;
  transferLock: Scalars['Boolean']['output'];
  /** Transfer timestamp */
  transferredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updateLock: Scalars['Boolean']['output'];
  /** Timestamp of the last update */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  whoisPrivacy: Scalars['Boolean']['output'];
};


/** Domain object */
export type DomainNameserversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Domain object */
export type DomainNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Domain object */
export type DomainSocialMediaAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Domain object */
export type DomainTrademarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Domain. */
export type DomainConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DomainEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Domain>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DomainEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Domain>;
};

export type DomainExportField = {
  default: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DomainExportFieldGroup = {
  fields: Array<DomainExportField>;
  label: Scalars['String']['output'];
};

export type DomainFilter = {
  blank?: InputMaybe<DomainFilterBlankOperator>;
  contains?: InputMaybe<DomainFilterContainsOperator>;
  containsNot?: InputMaybe<DomainFilterContainsNotOperator>;
  idnAndPunycodeDoNotEqualAny?: InputMaybe<DomainFilterIdnAndPunycodeDoNotEqualAnyOperator>;
  idnAndPunycodeDoNotMatchAny?: InputMaybe<DomainFilterIdnAndPunycodeDoNotMatchAnyOperator>;
  idnOrPunycodeEqualAny?: InputMaybe<DomainFilterIdnOrPunycodeEqualAnyOperator>;
  idnOrPunycodeMatchAny?: InputMaybe<DomainFilterIdnOrPunycodeMatchAnyOperator>;
  is?: InputMaybe<DomainFilterIsOperator>;
  isNot?: InputMaybe<DomainFilterIsNotOperator>;
  notBlank?: InputMaybe<DomainFilterNotBlankOperator>;
  willBeRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  withVisibleStates?: InputMaybe<DomainFilterWithVisibleStatesOperator>;
  withoutVisibleStates?: InputMaybe<DomainFilterWithoutVisibleStatesOperator>;
};

export enum DomainFilterBlankField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export type DomainFilterBlankOperator = {
  field: DomainFilterBlankField;
};

export type DomainFilterContainer = {
  filter?: InputMaybe<DomainFilter>;
  group?: InputMaybe<DomainFilterGroup>;
};

export enum DomainFilterContainsField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export enum DomainFilterContainsNotField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export type DomainFilterContainsNotOperator = {
  field: DomainFilterContainsNotField;
  query: Scalars['String']['input'];
};

export type DomainFilterContainsOperator = {
  field: DomainFilterContainsField;
  query: Scalars['String']['input'];
};

/** A group of child filters joined by an operation. */
export type DomainFilterGroup = {
  /** Child filter elements to be joined by the group operation */
  filters?: InputMaybe<Array<DomainFilterContainer>>;
  /** Grouping operator for associated filters */
  operator?: InputMaybe<FilterGroupOperator>;
};

export enum DomainFilterIdnAndPunycodeDoNotEqualAnyField {
  Name = 'name'
}

export type DomainFilterIdnAndPunycodeDoNotEqualAnyOperator = {
  field: DomainFilterIdnAndPunycodeDoNotEqualAnyField;
  query: Scalars['String']['input'];
};

export enum DomainFilterIdnAndPunycodeDoNotMatchAnyField {
  Name = 'name'
}

export type DomainFilterIdnAndPunycodeDoNotMatchAnyOperator = {
  field: DomainFilterIdnAndPunycodeDoNotMatchAnyField;
  query: Scalars['String']['input'];
};

export enum DomainFilterIdnOrPunycodeEqualAnyField {
  Name = 'name'
}

export type DomainFilterIdnOrPunycodeEqualAnyOperator = {
  field: DomainFilterIdnOrPunycodeEqualAnyField;
  query: Scalars['String']['input'];
};

export enum DomainFilterIdnOrPunycodeMatchAnyField {
  Name = 'name'
}

export type DomainFilterIdnOrPunycodeMatchAnyOperator = {
  field: DomainFilterIdnOrPunycodeMatchAnyField;
  query: Scalars['String']['input'];
};

export enum DomainFilterIsField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export enum DomainFilterIsNotField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export type DomainFilterIsNotOperator = {
  field: DomainFilterIsNotField;
  query: Scalars['String']['input'];
};

export type DomainFilterIsOperator = {
  field: DomainFilterIsField;
  query: Scalars['String']['input'];
};

export enum DomainFilterNotBlankField {
  BrandName = 'brand_name',
  DepartmentName = 'department_name',
  TldName = 'tld_name'
}

export type DomainFilterNotBlankOperator = {
  field: DomainFilterNotBlankField;
};

export type DomainFilterWithVisibleStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

export type DomainFilterWithoutVisibleStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

/** Domain group */
export type DomainGroup = {
  domains: Array<Domain>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DomainOrderBy = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  key: DomainOrderByKey;
};

export enum DomainOrderByKey {
  Brand = 'brand',
  Department = 'department',
  Name = 'name'
}

export enum DomainState {
  /** Not an actual domain, but a trademark block */
  TrademarkBlock = 'TRADEMARK_BLOCK',
  /** Active */
  Active = 'active',
  /** Admonition pending */
  Admonition = 'admonition',
  Deleted = 'deleted',
  /** Deletion pending */
  DeletionPending = 'deletion_pending',
  DisputeResolution = 'dispute_resolution',
  DomainBrokerage = 'domain_brokerage',
  DomainRecovery = 'domain_recovery',
  /** Non-binding expression of interest */
  Eoi = 'eoi',
  /** Domain has expired */
  Expired = 'expired',
  /** Unmanaged domain */
  External = 'external',
  /** Active with server hold */
  Hold = 'hold',
  /** Transitional state if an order has not yet been processed */
  New = 'new',
  /** Pre-order cancelled */
  PreorderCancelled = 'preorder_cancelled',
  /** Pre-order failed */
  PreorderFailed = 'preorder_failed',
  /** Pre-ordered */
  Preordered = 'preordered',
  /** Purchase pending */
  Purchase = 'purchase',
  /** Registration cancelled */
  RegistrationCancelled = 'registration_cancelled',
  /** Registration failed */
  RegistrationFailed = 'registration_failed',
  /** Registration pending */
  RegistrationPending = 'registration_pending',
  /** Snapback pending */
  Snapback = 'snapback',
  /** Takedown pending */
  Takedown = 'takedown',
  /** Transfer-in cancelled */
  TransferCancelled = 'transfer_cancelled',
  /** Transfer failed */
  TransferFailed = 'transfer_failed',
  /** Transfer-out pending */
  TransferOutPending = 'transfer_out_pending',
  /**  Transfer-in pending */
  TransferPending = 'transfer_pending',
  WhoisDisclosure = 'whois_disclosure'
}

/** Autogenerated return type of EditSSLCertificate. */
export type EditSslCertificatePayload = {
  /** The SSL certificate that was edited. */
  sslCertificate: SslCertificate;
};

export enum ExportFormat {
  /** Comma-separated values (CSV) in plain text, UTF-8 encoded without BOM */
  Csv = 'csv',
  /** Microsoft Excel spreadsheet (XLS), Base64 encoded because the binary document cannot be carried in a GraphQL String */
  Xls = 'xls'
}

export enum FilterGroupOperator {
  /** Logical AND */
  And = 'AND',
  /** Logical NOT AND (doubles as unary NOT) */
  Nand = 'NAND',
  /** Logical AND */
  Or = 'OR'
}

export type InfoLink = {
  /** A descriptive text */
  label: Scalars['String']['output'];
  /** The destination URL */
  url: Scalars['String']['output'];
};

/** Represents an invoice in the billing system. */
export type Invoice = Bill & {
  /** Additional references associated with this bill. */
  additionalReferences?: Maybe<Scalars['String']['output']>;
  /** Address associated with the bill. */
  address?: Maybe<Scalars['String']['output']>;
  /** 1st line of address associated with the bill. */
  address1?: Maybe<Scalars['String']['output']>;
  /** 2nd line of address associated with the bill. */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of the associated address. */
  city?: Maybe<Scalars['String']['output']>;
  /** Whether this bill is issued in the name of a client. */
  clientBilling?: Maybe<Scalars['Boolean']['output']>;
  /** Company name billing contact. */
  company?: Maybe<Scalars['String']['output']>;
  /** Contact name for the bill. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** ISO country code of the associated address. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Country name of the associated address. */
  countryName?: Maybe<Scalars['String']['output']>;
  /** State within the associated country. */
  countryState?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency in which the bill is denominated. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was downloaded. */
  downloadedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Due date of the invoice. */
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Email associated with the bill. */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the bill. */
  id: Scalars['ID']['output'];
  /** Date when the bill was issued. */
  issueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The bill will not be issued automatiaclly when this is set. */
  keepOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Invoice number of the bill. */
  number?: Maybe<Scalars['String']['output']>;
  /** The account this bill belongs to. */
  owner?: Maybe<Account>;
  /** Total amount paid for the invoice. */
  paidAmount?: Maybe<Scalars['Float']['output']>;
  /** End date of the billing period. */
  periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start date of the billing period. */
  periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The purchase order of the bill. */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** The recipient of the bill. */
  recipient?: Maybe<Recipient>;
  /** Type of the bill's recipient. */
  recipientType?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the bill was sent by email. */
  sentByEmail?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp when the bill was sent by post. */
  sentByPost?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status of the bill. */
  state?: Maybe<BillState>;
  /** Total net amount of the bill. */
  totalNetAmount?: Maybe<Scalars['Float']['output']>;
  /** Total tax amount in the bill. */
  totalTaxAmount?: Maybe<Scalars['Float']['output']>;
  /** The type of the bill, either Billing::Invoice or Billing::CreditNote. */
  type?: Maybe<Scalars['String']['output']>;
  /** Date when the bill was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** VAT ID for the bill. */
  vatId?: Maybe<Scalars['String']['output']>;
  /** Postal code of the associated address. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Represents a specific line item in an Invoice. */
export type InvoiceItem = {
  /** Specific action related to the Invoice line item. */
  action?: Maybe<Scalars['String']['output']>;
  /** Billing date for the Invoice line item. */
  billingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Currency in which the Invoice line item is denominated. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Name of the department related to the Invoice line item. */
  departmentName?: Maybe<Scalars['String']['output']>;
  /** Detailed description of the Invoice line item. */
  description?: Maybe<Scalars['String']['output']>;
  /** Exchange rate applied to the line item. */
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier of the Invoice line item. */
  id: Scalars['ID']['output'];
  /** Net amount of the Invoice line item before tax. */
  netAmount?: Maybe<Scalars['Float']['output']>;
  /** Whether the line item is non-refundable or not. */
  nonRefundable?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the object related to the Invoice line item. */
  objectName?: Maybe<Scalars['String']['output']>;
  /** End date of the period for which the line item is billed. */
  periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start date of the period for which the line item is billed. */
  periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Purchase order number of the Invoice line item. */
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  /** Quantity of the item on the Invoice line. */
  quantity: Scalars['Int']['output'];
  /** Current state of the Invoice line item. */
  state?: Maybe<Scalars['String']['output']>;
  /** ID of the subject (or related entity) of the line item. */
  subjectId?: Maybe<Scalars['Int']['output']>;
  /** Type of the subject (or related entity) of the line item. */
  subjectType?: Maybe<Scalars['String']['output']>;
  /** Tax details associated with the line item. */
  tax?: Maybe<Tax>;
  /** Total tax amount for the Invoice line item. */
  taxAmount?: Maybe<Scalars['Float']['output']>;
  /** The Top Level Domain (TLD) associated with the line item. */
  tld?: Maybe<Scalars['String']['output']>;
  /** Net amount of the line item before any currency conversion. */
  unconvertedNetAmount?: Maybe<Scalars['Float']['output']>;
  /** ID of the work request associated with the line item. */
  workRequestId?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for InvoiceItem. */
export type InvoiceItemConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InvoiceItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InvoiceItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InvoiceItem>;
};

export enum Language {
  /** Deutsch */
  De = 'de',
  /** English */
  En = 'en',
  /** English (GB) */
  EnGb = 'en_GB',
  /** French */
  Fr = 'fr'
}

/** Logbook entry object */
export type LogbookEntry = {
  /** The User who performed the tracked action/event */
  actingUser: User;
  /** Timestamp when the logbook entry was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The event for which the Logbook Entry was generated */
  event: Scalars['String']['output'];
  /** Unique identifier for the Logbook Entry */
  id: Scalars['ID']['output'];
  /** The IP Address from where the event was generated */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** The name of the entity logged in the Logbook Entry */
  objectName: Scalars['String']['output'];
  /** The Account that owns this Logbook Entry */
  owner: Account;
  /** The type of the entity logged in the Logbook Entry */
  thingType: Scalars['String']['output'];
};

/** The connection type for LogbookEntry. */
export type LogbookEntryConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LogbookEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LogbookEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LogbookEntryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LogbookEntry>;
};

export type LogbookEntryOrderBy = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  key: LogbookEntryOrderByKey;
};

export enum LogbookEntryOrderByKey {
  ClientNumber = 'clientNumber',
  Company = 'company',
  CreatedAt = 'createdAt',
  Event = 'event',
  IpAddress = 'ipAddress',
  ObjectName = 'objectName',
  ThingType = 'thingType'
}

export type ManagedNameserverSet = {
  /** Unique ID of the set, used to reference it. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Nameservers hosting the set. */
  nameservers: Array<Scalars['String']['output']>;
};

/** A monetary value with currency. */
export type Money = {
  /** The amount. */
  amount: Scalars['Float']['output'];
  /** ISO 4217 currency code. */
  currency: Currency;
};

export type Mutation = {
  /** Accepts the DPA */
  acceptDpa: AcceptDpaPayload;
  /** Changes the current user's password. */
  changePassword: ValidationErrors;
  /** Create a new account */
  createAccount: AccountType_ValidationResult;
  /** Mutation for creating DnsRecords. */
  createDnsRecord: DnsRecord;
  /** Bulk mutation for creating DNS records. */
  createDnsRecords: Array<DnsRecord>;
  /**
   * This mutation is used to create a primary DNS zone. Takes the domain name
   *       and managed nameserver set ID as arguments, checks for proper update DNS permissions,
   *       updates the managed nameserver set on the domain and creates the primary zone,
   *       then returns the newly created DNS zone
   */
  createPrimaryDnsZone: DnsZone;
  /**
   * This mutation is used to create a secondary DNS zone. Takes the domain name,
   *       managed_nameserver_set_id and primary nameserver IP addresses as arguments, checks for proper
   *       update DNS permission, updates the managed nameserver set on the domain and creates the
   *       secondary zone, then returns the newly created DNS zone
   */
  createSecondaryDnsZone: DnsZone;
  /** Creates a support ticket from the public frontend. */
  createTicket: TicketType_ValidationResult;
  createUser: UserType_ValidationResult;
  /** Mutation for deleting DnsRecords */
  deleteDnsRecord: DeleteDnsRecordPayload;
  /** Bulk mutation for deleting DNS records */
  deleteDnsRecords: DeleteDnsRecordsPayload;
  /** Deletes a primary or secondary DNS zone */
  deleteDnsZone: DeleteDnsZonePayload;
  /** Edits an SSL certificate */
  editSslCertificate: EditSslCertificatePayload;
  /** Logs an error with the provided details. */
  logError: Scalars['Boolean']['output'];
  /** Orders a new SSL certificate */
  orderSslCertificate: OrderSslCertificatePayload;
  /**
   * This mutation is used to publish a DNS zone. It takes a domain name
   *       as argument, checks for the right permissions and publishes the zone.
   */
  publishDnsZone: DnsZone;
  /** Renews an SSL certificate by submitting a renewal work request */
  renewSslCertificate: RenewSslCertificatePayload;
  /** Revokes an SSL certificate by submitting a deletion work request */
  revokeSslCertificate: RevokeSslCertificatePayload;
  /**
   * Mutation for setting a SOA serial of a DNS zone. This will not publish any other changes to the zone.
   *
   * Explicitly changing the SOA serial can cause issues with DNS caching. This is only meant for emergencies when you must perform zone updates after reaching the maximum SOA serial for backends that use the serial format YYYYMMDDNN, where NN is a daily counter, thus allowing only 100 increments per day.
   *
   */
  setSoaSerial: DnsRecordSoa;
  /** Update an account's details */
  updateAccount: Account;
  /** Mutation for updating DnsRecords */
  updateDnsRecord: DnsRecord;
  /** Bulk mutation for updating DnsRecords */
  updateDnsRecords: Array<DnsRecord>;
  /** Update the master ip addresses of a secondary dns zone */
  updateDnsZoneMasterIpAddresses: UpdateMasterIpAddressesPayload;
  updateUser: UserType_ValidationResult;
  /** Update user settings */
  updateUserSettings: UpdateUserSettingsPayload;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  language?: InputMaybe<Language>;
  password: Scalars['String']['input'];
};


export type MutationCreateAccountArgs = {
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: CountryCode;
  countryStateCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  login: Scalars['String']['input'];
  managerUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  parentClientNumber?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  street: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};


export type MutationCreateDnsRecordArgs = {
  input: DnsRecordAttributes;
};


export type MutationCreateDnsRecordsArgs = {
  inputs: Array<DnsRecordAttributes>;
};


export type MutationCreatePrimaryDnsZoneArgs = {
  input: PrimaryDnsZoneAttributes;
};


export type MutationCreateSecondaryDnsZoneArgs = {
  input: SecondaryDnsZoneAttributes;
};


export type MutationCreateTicketArgs = {
  input: TicketAttributes;
  turnstileToken: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  input: CreateUserAttributes;
  language?: InputMaybe<Language>;
};


export type MutationDeleteDnsRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDnsRecordsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDnsZoneArgs = {
  domainName: Scalars['String']['input'];
};


export type MutationEditSslCertificateArgs = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  costUnit?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  domainGroupId?: InputMaybe<Scalars['ID']['input']>;
  domainGroupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLogErrorArgs = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  route: Scalars['String']['input'];
  stackTrace?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationOrderSslCertificateArgs = {
  input: SslCertificateOrderAttributes;
};


export type MutationPublishDnsZoneArgs = {
  domainName: Scalars['String']['input'];
};


export type MutationRenewSslCertificateArgs = {
  csr?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  orderReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRevokeSslCertificateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetSoaSerialArgs = {
  domainName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  serial: Scalars['Int']['input'];
};


export type MutationUpdateAccountArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  clientNumber: Scalars['Int']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  countryStateCode?: InputMaybe<Scalars['String']['input']>;
  customClientNumber?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  forceOriginalPassword?: InputMaybe<Scalars['Boolean']['input']>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  passwordMinLength?: InputMaybe<Scalars['Int']['input']>;
  passwordTtl?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDnsRecordArgs = {
  input: DnsRecordAttributes;
};


export type MutationUpdateDnsRecordsArgs = {
  inputs: Array<DnsRecordAttributes>;
};


export type MutationUpdateDnsZoneMasterIpAddressesArgs = {
  domainName: Scalars['String']['input'];
  masters: Array<Scalars['String']['input']>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserAttributes;
  language?: InputMaybe<Language>;
};


export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};

export type Nameserver = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  ipAddresses: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registered: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Nameserver. */
export type NameserverConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NameserverEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Nameserver>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NameserverEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Nameserver>;
};

export type NameserverSet = {
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameservers: NameserverConnection;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type NameserverSetNameserversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Note = {
  author?: Maybe<User>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** The connection type for Note. */
export type NoteConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Note>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NoteEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Note>;
};

/** Autogenerated return type of OrderSSLCertificate. */
export type OrderSslCertificatePayload = {
  /** The order work request that was created. */
  workRequest: WorkRequestInterface;
};

/** A work request for ordering a new SSL certificate. */
export type OrderSslCertificateWorkRequest = WorkRequestInterface & {
  /** DNS resource records, in BIND syntax, required for domain control validation (across managed zones, delegated subzones and unmanaged zones). Empty when none are required, e.g. for email validation. */
  authResourceRecords: Array<Scalars['String']['output']>;
  /** When the work request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the work request reached a terminal state. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the work request. */
  id: Scalars['ID']['output'];
  /** Current state of the work request. */
  state: WorkRequestState;
  /** The SSL certificate created by this order. */
  subject?: Maybe<SslCertificate>;
  /** Name of the subject this work request operates on. */
  subjectName: Scalars['String']['output'];
  /** Total price of the work request. */
  totalPrice?: Maybe<Money>;
  /** The kind of work request. */
  type: WorkRequestKind;
  /** When the work request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A single permission. A user is permitted to perform an action if and only if a relevant permission is present. */
export type Permission = {
  action: Scalars['String']['output'];
  department?: Maybe<Department>;
  id: Scalars['ID']['output'];
  requireApproval?: Maybe<Scalars['Boolean']['output']>;
  requireTan?: Maybe<Scalars['Boolean']['output']>;
  subjectClass: Scalars['String']['output'];
};

/**
 * Attributes for creating primary DNS zones. Example:
 *
 * 	{
 * 	  domainName: "example.com",
 * 	  managedNameserverSetId: 1
 * 	}
 *
 */
export type PrimaryDnsZoneAttributes = {
  /** Domain name */
  domainName: Scalars['String']['input'];
  /** ID of the managed nameserver set */
  managedNameserverSetId: Scalars['ID']['input'];
};

/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type Query = {
  /** List Accounts */
  accounts: AccountConnection;
  /** Export accounts */
  accountsExport: Scalars['String']['output'];
  /**
   * Fetches the list of Invoices and Credit Notes for a user. You can filter the list by
   * using various parameters such as ID, number, state and dates. If you choose to filter by 'periodStart' or 'periodEnd',
   * both need to be specified together. To include child account bills, set 'children' to true and provide the 'ownerId'.
   * Note: If you lack the necessary permissions for the requested bills, the return value will be null. Returns an array
   * of Bill objects.
   */
  bills?: Maybe<BillConnection>;
  /** Retrieve branding information based on the host. Returns default branding information if no host-specific branding is found. */
  brandingByHost: Branding;
  /** Returns the active cart. */
  cart: Cart;
  checkDomainAvailablity: Array<CheckDomainAvailabilityResult>;
  /** Lists all states of a given country. */
  countryStates: Array<CountryState>;
  /** The account which's data is currently being acted upon */
  currentAccount?: Maybe<Account>;
  /** The currently acting user */
  currentUser?: Maybe<User>;
  /** Return the resource records for a given DNS zone. */
  dnsRecordsByZone: Array<DnsRecord>;
  /** Fetch a single DNS zone */
  dnsZone: DnsZone;
  /** Retrieve the differences of a DNS zone against the current zone on the DNS backend */
  dnsZoneDiff: DnsZoneDiff;
  /** Lists the DNS zones in your account */
  dnsZones: DnsZoneConnection;
  /** Export domains */
  domainExport: Scalars['String']['output'];
  /** Export domains fields */
  domainExportFieldGroups: Array<DomainExportFieldGroup>;
  /** List domains */
  domains: DomainConnection;
  /** Fetches the invoice items of an invoice or credit note */
  invoiceItems?: Maybe<InvoiceItemConnection>;
  /** Retrieve all logbook entries. Data is fetched using the LogbookEntries resolver. */
  logbookEntries: LogbookEntryConnection;
  /** Export logbook entries. */
  logbookEntriesExport: Scalars['String']['output'];
  /**
   * Managed nameserver sets available to the authenticated account.
   *
   * These nameserver sets specify the service where a zone is hosted.
   *
   */
  managedNameserverSets: Array<ManagedNameserverSet>;
  /** The original user */
  originalUser: User;
  /** Returns session data. */
  sessionData: SessionData;
  /** Fetch the SSL certificate types that are available to order. */
  sslCertificateTypes: Array<SslCertificateType>;
  /** Fetch SSL certificates with optional filters. */
  sslCertificates?: Maybe<SslCertificateConnection>;
  /** Returns a single users */
  user: User;
  /** List Users */
  users: UserConnection;
  /** Export users */
  usersExport: Scalars['String']['output'];
  /** Returns the users of a prospective parent account which can be granted management rights on a new child account. */
  usersForAccountManagement: UserConnection;
  /** Returns a list of users available for impersonation. */
  usersForImpersonation: UserConnection;
  /** Fetch work requests with optional filters. */
  workRequests?: Maybe<WorkRequestInterfaceConnection>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountFilterContainer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountOrderBy>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryAccountsExportArgs = {
  filter?: InputMaybe<AccountFilterContainer>;
  format?: InputMaybe<ExportFormat>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  children?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  ownerClientNumber?: InputMaybe<Scalars['ID']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  state?: InputMaybe<BillState>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryBrandingByHostArgs = {
  host?: InputMaybe<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryCheckDomainAvailablityArgs = {
  domainNames: Array<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryCountryStatesArgs = {
  country: CountryCode;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDnsRecordsByZoneArgs = {
  domainName: Scalars['String']['input'];
  filters?: InputMaybe<DnsRecordsFilters>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDnsZoneArgs = {
  domainName: Scalars['String']['input'];
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDnsZoneDiffArgs = {
  domainName: Scalars['String']['input'];
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDnsZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDomainExportArgs = {
  fields: Array<Scalars['String']['input']>;
  filter?: InputMaybe<DomainFilterContainer>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<DomainOrderBy>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DomainFilterContainer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DomainOrderBy>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryInvoiceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryLogbookEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LogbookEntryOrderBy>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryLogbookEntriesExportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<LogbookEntryOrderBy>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QuerySslCertificatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  certificateId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expiresAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  expiresAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  sslCertificateTypeName?: InputMaybe<Array<Scalars['String']['input']>>;
  sslCertificateTypeVendor?: InputMaybe<Array<SslCertificateVendor>>;
  state?: InputMaybe<Array<SslCertificateState>>;
  updatedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  validSinceAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  validSinceBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterContainer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryUsersExportArgs = {
  filter?: InputMaybe<UserFilterContainer>;
  format?: InputMaybe<ExportFormat>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryUsersForAccountManagementArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  parentClientNumber?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryUsersForImpersonationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * All of the queries require authentication. Please provide a valid JWT as the value of an
 * `Authorization` http header, with the `Bearer` scheme, e.g., `Authorization: Bearer <token>`
 *
 */
export type QueryWorkRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  createdAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  finishedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  finishedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<WorkRequestState>>;
  subjectId?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<WorkRequestKind>>;
  updatedAtAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  updatedAtBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Represents either an Account or a Department. */
export type Recipient = Account | Department;

/** Autogenerated return type of RenewSSLCertificate. */
export type RenewSslCertificatePayload = {
  /** The renewal work request that was created. */
  workRequest: WorkRequestInterface;
};

/** A work request for renewing an SSL certificate. */
export type RenewSslCertificateWorkRequest = WorkRequestInterface & {
  /** When the work request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the work request reached a terminal state. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the work request. */
  id: Scalars['ID']['output'];
  /** Renewal period in years. */
  period?: Maybe<Scalars['Int']['output']>;
  /** The SSL certificate being renewed. */
  renewedSslCertificate?: Maybe<SslCertificate>;
  /** Current state of the work request. */
  state: WorkRequestState;
  /** The new SSL certificate created by this renewal. */
  subject?: Maybe<SslCertificate>;
  /** Name of the subject this work request operates on. */
  subjectName: Scalars['String']['output'];
  /** Total price of the work request. */
  totalPrice?: Maybe<Money>;
  /** The kind of work request. */
  type: WorkRequestKind;
  /** When the work request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of RevokeSSLCertificate. */
export type RevokeSslCertificatePayload = {
  /** The revocation work request that was created. */
  workRequest: WorkRequestInterface;
};

/** A work request for revoking an SSL certificate. */
export type RevokeSslCertificateWorkRequest = WorkRequestInterface & {
  /** When the work request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the work request reached a terminal state. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the work request. */
  id: Scalars['ID']['output'];
  /** Current state of the work request. */
  state: WorkRequestState;
  /** The SSL certificate being revoked. */
  subject?: Maybe<SslCertificate>;
  /** Name of the subject this work request operates on. */
  subjectName: Scalars['String']['output'];
  /** The kind of work request. */
  type: WorkRequestKind;
  /** When the work request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SslCertificate = {
  /** Administrative contact of the certificate */
  adminContact?: Maybe<Contact>;
  /** Email addresses used to approve issuance of the certificate */
  approverEmails: Array<Scalars['String']['output']>;
  /** Domain control validation method used to authenticate the certificate */
  authMethod?: Maybe<SslCertificateAuthMethod>;
  /** Whether the certificate is automatically renewed before expiration */
  autoRenew: Scalars['Boolean']['output'];
  /** Billing contact of the certificate */
  billingContact?: Maybe<Contact>;
  /** Brand the certificate is assigned to */
  brand?: Maybe<Brand>;
  /** Identifier used by the CA backend to identify the certificate */
  certificateId?: Maybe<Scalars['ID']['output']>;
  /** Common name (CN) of the certificate, taken from the certificate or, if absent, the CSR */
  commonName?: Maybe<Scalars['String']['output']>;
  /** Cost unit assigned to the certificate */
  costUnit?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Issued certificate in PEM encoding */
  crt?: Maybe<Scalars['String']['output']>;
  /** Certificate Signing Request in PEM encoding */
  csr?: Maybe<Scalars['String']['output']>;
  /** Department the certificate is assigned to */
  department?: Maybe<Department>;
  /** Domain group the certificate is assigned to */
  domainGroup?: Maybe<DomainGroup>;
  /** Contact who approves issuance for Extended Validation certificates */
  evApproverContact?: Maybe<Contact>;
  /** Expiration time of the certificate (as set by the CA) */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the SSL certificate */
  id: Scalars['ID']['output'];
  /** Intermediate certificate chain in PEM encoding */
  intermediate?: Maybe<Scalars['String']['output']>;
  /** All names covered by the certificate (common name and SANs) */
  names: Array<Scalars['String']['output']>;
  /** Organization contact required for organization-validated certificates */
  organizationContact?: Maybe<Contact>;
  /** Organization person contact required for organization-validated certificates */
  organizationPersonContact?: Maybe<Contact>;
  /** Account that owns the certificate */
  owner: Account;
  /** Owner contact of the certificate */
  ownerContact?: Maybe<Contact>;
  /** Reference number assigned to the certificate */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** Serial number of the issued certificate as upper-case hexadecimal */
  serial?: Maybe<Scalars['String']['output']>;
  /** Product type of the certificate */
  sslCertificateType: SslCertificateType;
  /** Current lifecycle state of the certificate */
  state?: Maybe<SslCertificateState>;
  /** Technical contact of the certificate */
  techContact?: Maybe<Contact>;
  /** Timestamp of last update */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Start of the certificate validity period (as set by the CA) */
  validSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum SslCertificateAuthMethod {
  DnsCname = 'dns_cname',
  DnsTxt = 'dns_txt',
  Email = 'email',
  File = 'file',
  Http = 'http'
}

export enum SslCertificateAuthentication {
  Domain = 'domain',
  Extended = 'extended',
  Full = 'full'
}

/** The connection type for SSLCertificate. */
export type SslCertificateConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SslCertificateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SslCertificate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

export enum SslCertificateContactRequirement {
  Mandatory = 'mandatory',
  None = 'none',
  Optional = 'optional'
}

/** An edge in a connection. */
export type SslCertificateEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SslCertificate>;
};

/** Parameters for ordering a new SSL certificate */
export type SslCertificateOrderAttributes = {
  /**
   * Email addresses used to approve issuance of the certificate.
   *
   * Each address must have a local part of `admin@`, `administrator@`, `hostmaster@`, `webmaster@` or `postmaster@`, and a domain part matching the certificate's domain — e.g. `admin@example.com` approves a certificate for `www.example.com`. Every name on the certificate must be covered by one of the given addresses.
   *
   */
  approverEmails: Array<Scalars['String']['input']>;
  /** Domain control validation method used to authenticate the certificate */
  authMethod: SslCertificateAuthMethod;
  /** Whether the certificate should be automatically renewed before expiration. Defaults to the account setting. */
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the brand to assign the certificate to */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the brand to assign the certificate to */
  brandName?: InputMaybe<Scalars['String']['input']>;
  /** Cost unit to assign to the certificate */
  costUnit?: InputMaybe<Scalars['String']['input']>;
  /** Certificate Signing Request in PEM encoding */
  csr: Scalars['String']['input'];
  /** ID of the department to assign the certificate to */
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the department to assign the certificate to */
  departmentName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the domain group to assign the certificate to */
  domainGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the domain group to assign the certificate to */
  domainGroupName?: InputMaybe<Scalars['String']['input']>;
  /** Handle of the contact to set as EV approver contact for the certificate (required for EV certificates) */
  evApproverContactHandle?: InputMaybe<Scalars['String']['input']>;
  /** Reference for this order, e.g. a purchase order number. Recorded on the order request and not carried onto the issued certificate. For a persistent certificate reference, use `referenceNumber`. */
  orderReference?: InputMaybe<Scalars['String']['input']>;
  /** Handle of the contact to set as organization contact for the certificate (required for organization-validated certificates) */
  organizationContactHandle?: InputMaybe<Scalars['String']['input']>;
  /** Handle of the contact to set as organization person contact for the certificate (required for organization-validated certificates) */
  organizationPersonContactHandle?: InputMaybe<Scalars['String']['input']>;
  /** Handle of the contact to set as owner contact for the certificate. The admin, tech and billing contacts default to it. */
  ownerContactHandle?: InputMaybe<Scalars['String']['input']>;
  /** Reference number stored on the certificate itself; appears on the certificate and in billing/exports. For a reference specific to this order, use `orderReference`. */
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the certificate type to order */
  sslCertificateTypeIdentifier: Scalars['ID']['input'];
};

export enum SslCertificateState {
  /** The certificate has been issued and is currently valid. */
  Active = 'active',
  /** The certificate has expired. */
  Expired = 'expired',
  /** The certificate order is in a shopping cart and has not yet been submitted. */
  New = 'new',
  /** The initial certificate order was cancelled before issuance. */
  OrderCancelled = 'order_cancelled',
  /** The initial certificate order failed. */
  OrderFailed = 'order_failed',
  /** The initial certificate order has been submitted and is awaiting issuance. */
  Ordered = 'ordered',
  /** The certificate reissue was cancelled before issuance. */
  ReissueCancelled = 'reissue_cancelled',
  /** The certificate reissue failed. */
  ReissueFailed = 'reissue_failed',
  /** A reissue has been submitted and is awaiting issuance of the new certificate. */
  ReissuePending = 'reissue_pending',
  /** The certificate renewal was cancelled before issuance. */
  RenewalCancelled = 'renewal_cancelled',
  /** The certificate renewal failed. */
  RenewalFailed = 'renewal_failed',
  /** A renewal has been submitted and is awaiting issuance of the new certificate. */
  RenewalPending = 'renewal_pending',
  /** Revocation has been requested and is being processed. */
  RevocationPending = 'revocation_pending',
  /** The certificate has been revoked. */
  Revoked = 'revoked'
}

export type SslCertificateType = {
  /** Validation level required for this certificate type (domain, organization or extended) */
  authentication: SslCertificateAuthentication;
  /** Unique identifier of the certificate type, used when ordering certificates */
  identifier: Scalars['String']['output'];
  /** Number of domains included in the base price */
  includedDomains: Scalars['Int']['output'];
  /** Number of non-wildcard domains included in the base price */
  includedNonWildcardDomains: Scalars['Int']['output'];
  /** Number of wildcard domains included in the base price */
  includedWildcardDomains: Scalars['Int']['output'];
  /** Maximum total number of domains the certificate can cover */
  maxDomains: Scalars['Int']['output'];
  /** Maximum number of domains including alternative names (SANs) */
  maxDomainsIncludingAlternatives: Scalars['Int']['output'];
  /** Maximum number of alternative names (SANs) included at no extra cost */
  maxFreeAlternatives: Scalars['Int']['output'];
  /** Maximum number of non-wildcard domains the certificate can cover */
  maxNonWildcardDomains: Scalars['Int']['output'];
  /** Maximum number of wildcard domains the certificate can cover */
  maxWildcardDomains: Scalars['Int']['output'];
  /** Human-readable name of the certificate type */
  name: Scalars['String']['output'];
  /** Whether certificates of this type can be reissued */
  reissuable: Scalars['Boolean']['output'];
  /** Whether an EV approver contact is required, optional or not used */
  requiresEvApproverContact?: Maybe<SslCertificateContactRequirement>;
  /** Whether an organization contact is required, optional or not used */
  requiresOrganizationContact?: Maybe<SslCertificateContactRequirement>;
  /** Whether certificates of this type can be revoked */
  revocable?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of last update */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Certificate authority that issues certificates of this type */
  vendor: SslCertificateVendor;
};

export enum SslCertificateVendor {
  DigiCert = 'DigiCert',
  Generic = 'Generic',
  Geotrust = 'Geotrust',
  RapidSsl = 'RapidSSL',
  Sectigo = 'Sectigo',
  Thawte = 'Thawte'
}

/**
 * Attributes for creating secondary DNS zones. Example:
 *
 * 	{
 * 	  domainName: "example.com",
 * 	  managedNameserverSetId: "1",
 * 	  managedNameserverSetId: ["192.158.1.38", "1.2.3.4"]
 * 	}
 *
 */
export type SecondaryDnsZoneAttributes = {
  /** Domain name */
  domainName: Scalars['String']['input'];
  /** ID of the managed nameserver set */
  managedNameserverSetId: Scalars['ID']['input'];
  /** The list of IP addresses of the primary nameservers, IPv4 and IPv6 addresses are both supported. */
  primaryNameserverIps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SessionData = {
  passwordExpired: Scalars['Boolean']['output'];
};

export type Settings = {
  language: Scalars['String']['output'];
};

export type SocialMediaAccount = {
  domains: DomainConnection;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  login: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  responsibleEmail?: Maybe<Array<Scalars['String']['output']>>;
  responsiblePhone?: Maybe<Scalars['String']['output']>;
  trademarks: TrademarkConnection;
  uri?: Maybe<Scalars['String']['output']>;
};


export type SocialMediaAccountDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SocialMediaAccountTrademarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for SocialMediaAccount. */
export type SocialMediaAccountConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SocialMediaAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SocialMediaAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SocialMediaAccountEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SocialMediaAccount>;
};

/**
 * Represents a Tax entity in the Billing system, providing necessary tax details for
 * invoice calculations.
 */
export type Tax = {
  /** The short form or abbreviation of the tax name. */
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the tax entity. */
  id: Scalars['ID']['output'];
  /** The name of the tax. It is usually a category of tax like VAT, Sales Tax, etc. */
  name?: Maybe<Scalars['String']['output']>;
  /** The tax rate as a percentage. This is used for tax calculations in invoices. */
  rate?: Maybe<Scalars['Float']['output']>;
  /** The date from when the particular tax rate is in effect. */
  validFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date until when the particular tax rate is in effect. */
  validTo?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A support ticket created from the public frontend */
export type Ticket = {
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  message: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating a support ticket from the public frontend */
export type TicketAttributes = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TicketType_ValidationResult = Ticket | ValidationErrors;

/** A top-level domain */
export type Tld = {
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Internationalized domain name (IDN) */
  idn: Scalars['String']['output'];
  /** The two-letter ISO 3166 code for this TLD's country or "ZZ" for gTLDs */
  iso3166Code?: Maybe<CountryCode>;
  /** Domain name in punycode representation */
  name: Scalars['String']['output'];
  supportsTransferLock: Scalars['Boolean']['output'];
  topLevel: Scalars['String']['output'];
};

export type Trademark = {
  brand?: Maybe<Brand>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Trademark. */
export type TrademarkConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TrademarkEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Trademark>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TrademarkEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Trademark>;
};

export type TranslatedInfoLinks = {
  /** Language code */
  language: Scalars['String']['output'];
  /** A collection of links */
  links: Array<InfoLink>;
};

/** Autogenerated return type of UpdateMasterIpAddresses. */
export type UpdateMasterIpAddressesPayload = {
  /** The DNS zone that was modified */
  dnsZone: DnsZone;
};

export type UpdateUserAttributes = {
  allowedIpAddresses?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  commercialRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryState: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  idCardNumber?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastname: Scalars['String']['input'];
  login: Scalars['String']['input'];
  /** State or province if the country subdivision is not in ISO 3166-2 */
  otherState?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  street: Scalars['String']['input'];
  taxNumberCompany?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserSettings. */
export type UpdateUserSettingsPayload = {
  errors?: Maybe<Array<Scalars['String']['output']>>;
  user?: Maybe<User>;
};

/** A user is the fundamental AC structure of this API */
export type User = {
  acceptDpa: Scalars['Boolean']['output'];
  /** The account this user belongs to */
  account?: Maybe<Account>;
  allowedIpAddresses?: Maybe<Scalars['String']['output']>;
  authorization: Authorization;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  /** The client's unique identifier; not set for users with status 'new' */
  clientNumber?: Maybe<Scalars['String']['output']>;
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  country: CountryCode;
  countryState?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idCardNumber?: Maybe<Scalars['String']['output']>;
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastname: Scalars['String']['output'];
  login: Scalars['String']['output'];
  otherState?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  settings: Settings;
  state: UserState;
  street: Scalars['String']['output'];
  taxNumberCompany?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

/** The connection type for User. */
export type UserConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total count of nodes */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFilter = {
  blank?: InputMaybe<UserFilterBlankOperator>;
  contains?: InputMaybe<UserFilterContainsOperator>;
  containsNot?: InputMaybe<UserFilterContainsNotOperator>;
  is?: InputMaybe<UserFilterIsOperator>;
  isNot?: InputMaybe<UserFilterIsNotOperator>;
  notBlank?: InputMaybe<UserFilterNotBlankOperator>;
  withStates?: InputMaybe<UserFilterWithStatesOperator>;
  withoutStates?: InputMaybe<UserFilterWithoutStatesOperator>;
};

export enum UserFilterBlankField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type UserFilterBlankOperator = {
  field: UserFilterBlankField;
};

export type UserFilterContainer = {
  filter?: InputMaybe<UserFilter>;
  group?: InputMaybe<UserFilterGroup>;
};

export enum UserFilterContainsField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Email = 'email',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Login = 'login',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export enum UserFilterContainsNotField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Email = 'email',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Login = 'login',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type UserFilterContainsNotOperator = {
  field: UserFilterContainsNotField;
  query: Scalars['String']['input'];
};

export type UserFilterContainsOperator = {
  field: UserFilterContainsField;
  query: Scalars['String']['input'];
};

/** A group of child filters joined by an operation. */
export type UserFilterGroup = {
  /** Child filter elements to be joined by the group operation */
  filters?: InputMaybe<Array<UserFilterContainer>>;
  /** Grouping operator for associated filters */
  operator?: InputMaybe<FilterGroupOperator>;
};

export enum UserFilterIsField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Email = 'email',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Login = 'login',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export enum UserFilterIsNotField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Email = 'email',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Login = 'login',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type UserFilterIsNotOperator = {
  field: UserFilterIsNotField;
  query: Scalars['String']['input'];
};

export type UserFilterIsOperator = {
  field: UserFilterIsField;
  query: Scalars['String']['input'];
};

export enum UserFilterNotBlankField {
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  Company = 'company',
  Country = 'country',
  Fax = 'fax',
  Firstname = 'firstname',
  Lastname = 'lastname',
  Phone = 'phone',
  Street = 'street',
  Zip = 'zip'
}

export type UserFilterNotBlankOperator = {
  field: UserFilterNotBlankField;
};

export type UserFilterWithStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

export type UserFilterWithoutStatesOperator = {
  query: Array<Scalars['String']['input']>;
};

export type UserOrderBy = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  key: UserOrderByKey;
};

export enum UserOrderByKey {
  AccountClientNumber = 'account_client_number',
  AccountCompany = 'account_company',
  CellPhone = 'cell_phone',
  City = 'city',
  ClientNumber = 'client_number',
  CommercialRegisterNumber = 'commercial_register_number',
  Company = 'company',
  Country = 'country',
  Email = 'email',
  Fax = 'fax',
  Firstname = 'firstname',
  LastSignInAt = 'last_sign_in_at',
  Lastname = 'lastname',
  Login = 'login',
  OtherState = 'other_state',
  Phone = 'phone',
  State = 'state',
  Street = 'street',
  TaxNumberCompany = 'tax_number_company',
  Zip = 'zip'
}

/** Input for updating user settings */
export type UserSettingsInput = {
  /** The user's preferred language. Must be one of the supported language codes. */
  language?: InputMaybe<Scalars['String']['input']>;
};

export enum UserState {
  /** The user has been activated and is usable */
  Active = 'active',
  /** The user has been deleted */
  Deleted = 'deleted',
  /** The user has not yet set a password */
  Fledgling = 'fledgling',
  /** The user is new and has not yet been activated. */
  New = 'new',
  /** The user has been suspended */
  Suspended = 'suspended'
}

export type UserType_ValidationResult = User | ValidationErrors;

/** A validation error */
export type ValidationError = {
  /** The error message including the name of the attribute it belongs to, for display where no field label is present */
  fullMessage: Scalars['String']['output'];
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
  /** The type of the error */
  type: Scalars['String']['output'];
};

/** A collection of validation errors. */
export type ValidationErrors = {
  validationMessages: Array<ValidationError>;
};

export enum WebForwardTypes {
  Frame = 'frame',
  Permanent = 'permanent',
  Temporary = 'temporary'
}

/** A work request representing an asynchronous operation. */
export type WorkRequest = WorkRequestInterface & {
  /** When the work request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the work request reached a terminal state. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the work request. */
  id: Scalars['ID']['output'];
  /** Current state of the work request. */
  state: WorkRequestState;
  /** Name of the subject this work request operates on. */
  subjectName: Scalars['String']['output'];
  /** The kind of work request. */
  type: WorkRequestKind;
  /** When the work request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A work request representing an asynchronous operation. */
export type WorkRequestInterface = {
  /** When the work request was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the work request reached a terminal state. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier of the work request. */
  id: Scalars['ID']['output'];
  /** Current state of the work request. */
  state: WorkRequestState;
  /** Name of the subject this work request operates on. */
  subjectName: Scalars['String']['output'];
  /** The kind of work request. */
  type: WorkRequestKind;
  /** When the work request was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for WorkRequestInterface. */
export type WorkRequestInterfaceConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkRequestInterfaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WorkRequestInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WorkRequestInterfaceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkRequestInterface>;
};

/** The kind of work request, derived from its STI class. */
export enum WorkRequestKind {
  /** Analysis */
  Analysis = 'ANALYSIS',
  /** Domain application */
  ApplyDomain = 'APPLY_DOMAIN',
  /** Consultation */
  Consultation = 'CONSULTATION',
  /** Content monitoring */
  ContentMonitoring = 'CONTENT_MONITORING',
  /** Domain deletion */
  DeleteDomain = 'DELETE_DOMAIN',
  /** Revoke SSL Certificate */
  DeleteSslCertificate = 'DELETE_SSL_CERTIFICATE',
  /** DNS resource record export */
  DnsResourceRecordDocumentExport = 'DNS_RESOURCE_RECORD_DOCUMENT_EXPORT',
  /** DNS zone export */
  DnsZoneDocumentExport = 'DNS_ZONE_DOCUMENT_EXPORT',
  /** DNS zone import */
  DnsZoneImport = 'DNS_ZONE_IMPORT',
  /** Domain audit */
  DomainAudit = 'DOMAIN_AUDIT',
  /** Expression of interest for domain */
  DomainEoi = 'DOMAIN_EOI',
  /** Domain monitoring */
  DomainMonitoring = 'DOMAIN_MONITORING',
  /** DVAG affiliate registration */
  DvagAffiliateRequest = 'DVAG_AFFILIATE_REQUEST',
  /** DNS change */
  EditDns = 'EDIT_DNS',
  /** Logo monitoring */
  LogoMonitoring = 'LOGO_MONITORING',
  /** Manage domain locks */
  ManageDomainLock = 'MANAGE_DOMAIN_LOCK',
  /** Domain modification */
  ModifyDomain = 'MODIFY_DOMAIN',
  /** TMCH modification */
  ModifyTrademark = 'MODIFY_TRADEMARK',
  /** Order monitoring */
  OrderMonitoring = 'ORDER_MONITORING',
  /** Order SSL Certificate */
  OrderSslCertificate = 'ORDER_SSL_CERTIFICATE',
  /** Domain acquisition */
  PurchaseDomain = 'PURCHASE_DOMAIN',
  /** Domain recovery */
  RecoverDomain = 'RECOVER_DOMAIN',
  /** Domain registration */
  RegisterDomain = 'REGISTER_DOMAIN',
  /** TMCH registration */
  RegisterTrademark = 'REGISTER_TRADEMARK',
  /** Registrant search/monitoring */
  RegistrantSearch = 'REGISTRANT_SEARCH',
  /** Reissue SSL Certificate */
  ReissueSslCertificate = 'REISSUE_SSL_CERTIFICATE',
  /** Remove transfer-lock */
  RemoveTransferLock = 'REMOVE_TRANSFER_LOCK',
  /** Domain renewal */
  RenewDomain = 'RENEW_DOMAIN',
  /** Renew monitoring */
  RenewMonitoring = 'RENEW_MONITORING',
  /** Renew SSL Certificate */
  RenewSslCertificate = 'RENEW_SSL_CERTIFICATE',
  /** Renew TMCH registration */
  RenewTmchRegistration = 'RENEW_TMCH_REGISTRATION',
  /** Report */
  Report = 'REPORT',
  /** Authcode reporting */
  ReportAuthcode = 'REPORT_AUTHCODE',
  /** Dispute resolution */
  ResolveDispute = 'RESOLVE_DISPUTE',
  /** Set transfer-lock */
  SetTransferLock = 'SET_TRANSFER_LOCK',
  /** Backorder */
  Snapback = 'SNAPBACK',
  /** Social media */
  SocialMediaMonitoring = 'SOCIAL_MEDIA_MONITORING',
  /** Takedown */
  Takedown = 'TAKEDOWN',
  /** Domain transfer */
  TransferDomain = 'TRANSFER_DOMAIN',
  /** Transfer-out domain */
  TransferOutDomain = 'TRANSFER_OUT_DOMAIN',
  /** Verify email address with aws */
  VerifyEmailAddressWithAws = 'VERIFY_EMAIL_ADDRESS_WITH_AWS',
  /** Web page and Whois monitoring */
  WebPageAndWhoisMonitoring = 'WEB_PAGE_AND_WHOIS_MONITORING'
}

export enum WorkRequestState {
  /**
   * The work request has been deleted.
   * @deprecated No longer assigned to new work requests; retained because older records may still have this state.
   */
  Deleted = 'DELETED',
  /** The work request failed. */
  Failed = 'FAILED',
  /** The work request finished successfully. */
  Finished = 'FINISHED',
  /** The work request is missing required information. */
  Incomplete = 'INCOMPLETE',
  /** The work request is in a shopping cart and has not yet been submitted. */
  New = 'NEW',
  /** The work request is being processed. */
  Processing = 'PROCESSING',
  /** The work request is waiting for being processed. */
  Queued = 'QUEUED',
  /** The work request is waiting for approval or rejection. */
  Review = 'REVIEW',
  /** The work request has been paused. */
  Stashed = 'STASHED'
}

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

export type AcceptDpaMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptDpaMutation = { acceptDpa: { user: { id: string, acceptDpa: boolean, email: string } } };

export type AccountFieldsFragment = { id: string, company: string, clientNumber?: number | null, state: AccountState, street: string, zip: string, city: string, country: CountryCode, countryState?: string | null, otherState?: string | null, phone: string };

export type AccountForEditQueryVariables = Exact<{
  clientNumber: Scalars['String']['input'];
}>;


export type AccountForEditQuery = { accounts: { edges?: Array<{ node?: { id: string, company: string, clientNumber?: number | null, state: AccountState, street: string, zip: string, city: string, country: CountryCode, countryState?: string | null, otherState?: string | null, phone: string, fax?: string | null, passwordTtl?: number | null, passwordMinLength?: number | null, forceOriginalPassword?: boolean | null } | null } | null> | null } };

export type AccountsExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AccountFilterContainer>;
}>;


export type AccountsExportQuery = { accountsExport: string };

export type AccountsForAutoCompleteFieldsFragment = { id: string, clientNumber?: number | null, company: string };

export type AccountsForAutoCompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type AccountsForAutoCompleteQuery = { accounts: { nodes?: Array<AccountsForAutoCompleteFieldsFragment | null> | null } };

export type AccountsForSelectionQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AccountsForSelectionQuery = { accounts: { edges?: Array<{ node?: { clientNumber?: number | null, company: string, parent?: { clientNumber?: number | null, company: string } | null } | null } | null> | null } };

export type AccountsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountOrderBy>;
  count: Scalars['Boolean']['input'];
  filter?: InputMaybe<AccountFilterContainer>;
}>;


export type AccountsQuery = { accounts: { totalCount?: number, edges?: Array<{ node?: AccountFieldsFragment | null } | null> | null } };

export type BrandingByHostQueryVariables = Exact<{
  host: Scalars['String']['input'];
}>;


export type BrandingByHostQuery = { brandingByHost: BrandingFieldsFragment };

export type BrandingFieldsFragment = { pageTitle: string, colorTheme?: ColorThemeFieldsFragment | null, infoLinks: Array<{ language: string, links: Array<{ label: string, url: string }> }> };

export type CartSizeQueryVariables = Exact<{ [key: string]: never; }>;


export type CartSizeQuery = { cart: { size: number } };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  language: Language;
}>;


export type ChangePasswordMutation = { changePassword: { validationMessages: Array<ValidationErrorFieldsFragment> } };

export type ColorThemeFieldsFragment = { accent?: string | null, bodyBackground?: string | null, navigationMainMenuHeader?: string | null, navigationMainMenuTitle?: string | null, pageTitle?: string | null };

export type CountryStatesQueryVariables = Exact<{
  country: CountryCode;
}>;


export type CountryStatesQuery = { countryStates: Array<{ name: string, isoCode: string }> };

export type CountryCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryCodesQuery = { __type?: { name?: string | null, enumValues?: Array<{ name: string }> | null } | null };

export type CreateTicketMutationVariables = Exact<{
  input: TicketAttributes;
  turnstileToken: Scalars['String']['input'];
}>;


export type CreateTicketMutation = { createTicket: { __typename: 'Ticket', id: string, title?: string | null } | { __typename: 'ValidationErrors', validationMessages: Array<ValidationErrorFieldsFragment> } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserAttributes;
  language?: InputMaybe<Language>;
}>;


export type CreateUserMutation = { createUser: { __typename: 'User', id: string } | { __typename: 'ValidationErrors', validationMessages: Array<ValidationErrorFieldsFragment> } };

export type CreateAccountMutationVariables = Exact<{
  parentClientNumber?: InputMaybe<Scalars['Int']['input']>;
  managerUserIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  company: Scalars['String']['input'];
  street: Scalars['String']['input'];
  city: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  country: CountryCode;
  countryState?: InputMaybe<Scalars['String']['input']>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  login: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  cellPhone?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAccountMutation = { createAccount: { __typename: 'Account', clientNumber?: number | null } | { __typename: 'ValidationErrors', validationMessages: Array<ValidationErrorFieldsFragment> } };

export type CurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountQuery = { currentAccount?: { branding: BrandingFieldsFragment } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser?: { allowedIpAddresses?: string | null, cellPhone?: string | null, city: string, clientNumber?: string | null, commercialRegisterNumber?: string | null, company: string, country: CountryCode, countryState?: string | null, email: string, fax?: string | null, firstname: string, id: string, lastSignInAt?: any | null, lastname: string, otherState?: string | null, phone: string, state: UserState, street: string, taxNumberCompany?: string | null, zip: string, acceptDpa: boolean, account?: { clientNumber?: number | null, company: string } | null, authorization: { isAdmin: boolean, featureAccess: Array<AuthFeature>, brandProtectionAccess: Array<BrandProtectionFeature>, permissions: Array<{ subjectClass: string, action: string, requireTan?: boolean | null }> }, settings: { language: string } } | null };

export type DomainContactFieldsFragment = { handle: string, firstname?: string | null, lastname?: string | null, fax?: string | null, street: Array<string | null>, company?: string | null, city: string, zip: string, phone: string, email: string };

export type DomainExportFieldGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DomainExportFieldGroupsQuery = { domainExportFieldGroups: Array<{ label: string, fields: Array<{ label: string, value: string, default: boolean }> }> };

export type DomainExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  fields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orderBy?: InputMaybe<DomainOrderBy>;
  filter?: InputMaybe<DomainFilterContainer>;
}>;


export type DomainExportQuery = { domainExport: string };

export type DomainFieldsFragment = { id: string, name: string, state: DomainState, idn: string, basename: string, expiresAt?: any | null, transferredAt?: any | null, updatedAt: any, transferLock: boolean, updateLock: boolean, deleteLock: boolean, clientManaged: boolean, renewalMode?: string | null, premium: boolean, supportsAuthcode: boolean, whoisPrivacy: boolean, costUnit?: string | null, owner: { clientNumber?: number | null, company: string }, brand?: { name: string } | null, department?: { name: string } | null, tld: { name: string }, adminContact?: DomainContactFieldsFragment | null, ownerContact?: DomainContactFieldsFragment | null, techContact?: DomainContactFieldsFragment | null, billingContact?: DomainContactFieldsFragment | null };

export type DomainsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DomainOrderBy>;
  count: Scalars['Boolean']['input'];
  filter?: InputMaybe<DomainFilterContainer>;
}>;


export type DomainsQuery = { domains: { totalCount?: number, edges?: Array<{ node?: DomainFieldsFragment | null } | null> | null } };

export type LogErrorMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  route: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stackTrace?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogErrorMutation = { logError: boolean };

export type LogbookEntriesExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<LogbookEntryOrderBy>;
}>;


export type LogbookEntriesExportQuery = { logbookEntriesExport: string };

export type LogbookEntriesFieldsFragment = { id: string, createdAt: any, event: string, thingType: string, objectName: string, ipAddress?: string | null, owner: { clientNumber?: number | null, company: string } };

export type LogbookEntriesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LogbookEntryOrderBy>;
  count: Scalars['Boolean']['input'];
}>;


export type LogbookEntriesQuery = { logbookEntries: { totalCount?: number, edges?: Array<{ node?: LogbookEntriesFieldsFragment | null } | null> | null } };

export type OriginalUserFieldsFragment = { id: string, clientNumber?: string | null, firstname: string, lastname: string, company: string, email: string };

export type OriginalUserQueryVariables = Exact<{ [key: string]: never; }>;


export type OriginalUserQuery = { originalUser: OriginalUserFieldsFragment };

export type SessionDataFieldsFragment = { passwordExpired: boolean };

export type SessionDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionDataQuery = { sessionData: SessionDataFieldsFragment };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserAttributes;
  language?: InputMaybe<Language>;
}>;


export type UpdateUserMutation = { updateUser: { __typename: 'User', id: string } | { __typename: 'ValidationErrors', validationMessages: Array<ValidationErrorFieldsFragment> } };

export type UpdateAccountMutationVariables = Exact<{
  clientNumber: Scalars['Int']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  countryState?: InputMaybe<Scalars['String']['input']>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  passwordTtl?: InputMaybe<Scalars['Int']['input']>;
  passwordMinLength?: InputMaybe<Scalars['Int']['input']>;
  forceOriginalPassword?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAccountMutation = { updateAccount: { id: string, clientNumber?: number | null, company: string, street: string, city: string, zip: string, country: CountryCode, phone: string, fax?: string | null, passwordTtl?: number | null, passwordMinLength?: number | null, forceOriginalPassword?: boolean | null } };

export type UpdateUserLanguageMutationVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type UpdateUserLanguageMutation = { updateUserSettings: { errors?: Array<string> | null, user?: { id: string, settings: { language: string } } | null } };

export type UserFieldsFragment = { id: string, email: string, login: string, firstname: string, lastname: string, state: UserState, company: string, street: string, zip: string, city: string, country: CountryCode, countryState?: string | null, otherState?: string | null, phone: string, fax?: string | null, cellPhone?: string | null, lastSignInAt?: any | null, allowedIpAddresses?: string | null, commercialRegisterNumber?: string | null, taxNumberCompany?: string | null, clientNumber?: string | null, account?: { clientNumber?: number | null, company: string } | null };

export type UserForUpdateFieldsFragment = { allowedIpAddresses?: string | null, cellPhone?: string | null, city: string, commercialRegisterNumber?: string | null, company: string, country: CountryCode, countryState?: string | null, email: string, fax?: string | null, firstname: string, idCardNumber?: string | null, lastname: string, login: string, otherState?: string | null, phone: string, street: string, taxNumberCompany?: string | null, title?: string | null, zip: string, settings: { language: string } };

export type UserForUpdateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserForUpdateQuery = { user: UserForUpdateFieldsFragment };

export type UsersExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<UserFilterContainer>;
}>;


export type UsersExportQuery = { usersExport: string };

export type UsersForAccountManagementFieldsFragment = { id: string, firstname: string, lastname: string, email: string, account?: { clientNumber?: number | null, company: string } | null };

export type UsersForAccountManagementQueryVariables = Exact<{
  parentClientNumber?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UsersForAccountManagementQuery = { usersForAccountManagement: { totalCount: number, nodes?: Array<UsersForAccountManagementFieldsFragment | null> | null } };

export type UsersForImpersonationFieldsFragment = { id: string, email: string, firstname: string, lastname: string, company: string, clientNumber?: string | null };

export type UsersForImpersonationQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  count: Scalars['Boolean']['input'];
}>;


export type UsersForImpersonationQuery = { usersForImpersonation: { totalCount?: number, nodes?: Array<UsersForImpersonationFieldsFragment | null> | null } };

export type UsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  count: Scalars['Boolean']['input'];
  filter?: InputMaybe<UserFilterContainer>;
}>;


export type UsersQuery = { users: { totalCount?: number, edges?: Array<{ node?: UserFieldsFragment | null } | null> | null } };

export type ValidationErrorFieldsFragment = { type: string, message: string, fullMessage: string, path?: Array<string> | null };

export const AccountFieldsFragmentDoc = gql`
    fragment accountFields on Account {
  id
  company
  clientNumber
  state
  street
  zip
  city
  country
  countryState
  otherState
  phone
}
    `;
export const AccountsForAutoCompleteFieldsFragmentDoc = gql`
    fragment accountsForAutoCompleteFields on Account {
  id
  clientNumber
  company
}
    `;
export const ColorThemeFieldsFragmentDoc = gql`
    fragment ColorThemeFields on ColorTheme {
  accent
  bodyBackground
  navigationMainMenuHeader
  navigationMainMenuTitle
  pageTitle
}
    `;
export const BrandingFieldsFragmentDoc = gql`
    fragment brandingFields on Branding {
  colorTheme {
    ...ColorThemeFields
  }
  pageTitle
  infoLinks {
    language
    links {
      label
      url
    }
  }
}
    ${ColorThemeFieldsFragmentDoc}`;
export const DomainContactFieldsFragmentDoc = gql`
    fragment domainContactFields on Contact {
  handle
  firstname
  lastname
  fax
  street
  company
  city
  zip
  phone
  email
}
    `;
export const DomainFieldsFragmentDoc = gql`
    fragment domainFields on Domain {
  id
  name
  owner {
    clientNumber
    company
  }
  brand {
    name
  }
  department {
    name
  }
  state
  tld {
    name
  }
  idn
  basename
  expiresAt
  transferredAt
  updatedAt
  transferLock
  updateLock
  deleteLock
  clientManaged
  renewalMode
  premium
  supportsAuthcode
  whoisPrivacy
  costUnit
  adminContact {
    ...domainContactFields
  }
  ownerContact {
    ...domainContactFields
  }
  techContact {
    ...domainContactFields
  }
  billingContact {
    ...domainContactFields
  }
}
    ${DomainContactFieldsFragmentDoc}`;
export const LogbookEntriesFieldsFragmentDoc = gql`
    fragment logbookEntriesFields on LogbookEntry {
  id
  createdAt
  event
  thingType
  objectName
  ipAddress
  owner {
    clientNumber
    company
  }
}
    `;
export const OriginalUserFieldsFragmentDoc = gql`
    fragment originalUserFields on User {
  id
  clientNumber
  firstname
  lastname
  company
  email
}
    `;
export const SessionDataFieldsFragmentDoc = gql`
    fragment sessionDataFields on SessionData {
  passwordExpired
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  account {
    clientNumber
    company
  }
  email
  login
  firstname
  lastname
  state
  company
  street
  zip
  city
  country
  countryState
  otherState
  phone
  fax
  cellPhone
  lastSignInAt
  allowedIpAddresses
  commercialRegisterNumber
  taxNumberCompany
  clientNumber
}
    `;
export const UserForUpdateFieldsFragmentDoc = gql`
    fragment userForUpdateFields on User {
  allowedIpAddresses
  cellPhone
  city
  commercialRegisterNumber
  company
  country
  countryState
  email
  fax
  firstname
  idCardNumber
  settings {
    language
  }
  lastname
  login
  otherState
  phone
  street
  taxNumberCompany
  title
  zip
}
    `;
export const UsersForAccountManagementFieldsFragmentDoc = gql`
    fragment usersForAccountManagementFields on User {
  id
  firstname
  lastname
  email
  account {
    clientNumber
    company
  }
}
    `;
export const UsersForImpersonationFieldsFragmentDoc = gql`
    fragment usersForImpersonationFields on User {
  id
  email
  firstname
  lastname
  company
  clientNumber
}
    `;
export const ValidationErrorFieldsFragmentDoc = gql`
    fragment validationErrorFields on ValidationError {
  type
  message
  fullMessage
  path
}
    `;
export const AcceptDpaDocument = gql`
    mutation AcceptDpa {
  acceptDpa {
    user {
      id
      acceptDpa
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptDpaGQL extends Apollo.Mutation<AcceptDpaMutation, AcceptDpaMutationVariables> {
    override document = AcceptDpaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountForEditDocument = gql`
    query AccountForEdit($clientNumber: String!) {
  accounts(
    first: 1
    filter: {filter: {is: {field: client_number, query: $clientNumber}}}
  ) {
    edges {
      node {
        id
        company
        clientNumber
        state
        street
        zip
        city
        country
        countryState
        otherState
        phone
        fax
        passwordTtl
        passwordMinLength
        forceOriginalPassword
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountForEditGQL extends Apollo.Query<AccountForEditQuery, AccountForEditQueryVariables> {
    override document = AccountForEditDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountsExportDocument = gql`
    query AccountsExport($ids: [ID!], $filter: AccountFilterContainer) {
  accountsExport(ids: $ids, filter: $filter)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountsExportGQL extends Apollo.Query<AccountsExportQuery, AccountsExportQueryVariables> {
    override document = AccountsExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountsForAutoCompleteDocument = gql`
    query AccountsForAutoComplete($query: String!) {
  accounts(query: $query) {
    nodes {
      ...accountsForAutoCompleteFields
    }
  }
}
    ${AccountsForAutoCompleteFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountsForAutoCompleteGQL extends Apollo.Query<AccountsForAutoCompleteQuery, AccountsForAutoCompleteQueryVariables> {
    override document = AccountsForAutoCompleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountsForSelectionDocument = gql`
    query AccountsForSelection($after: String, $first: Int, $states: [String!]!) {
  accounts(
    first: $first
    after: $after
    filter: {filter: {withStates: {query: $states}}}
  ) {
    edges {
      node {
        clientNumber
        company
        parent {
          clientNumber
          company
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountsForSelectionGQL extends Apollo.Query<AccountsForSelectionQuery, AccountsForSelectionQueryVariables> {
    override document = AccountsForSelectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AccountsDocument = gql`
    query Accounts($after: String, $before: String, $first: Int, $last: Int, $orderBy: AccountOrderBy, $count: Boolean!, $filter: AccountFilterContainer) {
  accounts(
    first: $first
    before: $before
    after: $after
    last: $last
    orderBy: $orderBy
    filter: $filter
  ) {
    edges {
      node {
        ...accountFields
      }
    }
    totalCount @include(if: $count)
  }
}
    ${AccountFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountsGQL extends Apollo.Query<AccountsQuery, AccountsQueryVariables> {
    override document = AccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BrandingByHostDocument = gql`
    query BrandingByHost($host: String!) {
  brandingByHost(host: $host) {
    ...brandingFields
  }
}
    ${BrandingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BrandingByHostGQL extends Apollo.Query<BrandingByHostQuery, BrandingByHostQueryVariables> {
    override document = BrandingByHostDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CartSizeDocument = gql`
    query CartSize {
  cart {
    size
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CartSizeGQL extends Apollo.Query<CartSizeQuery, CartSizeQueryVariables> {
    override document = CartSizeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangePasswordDocument = gql`
    mutation ChangePassword($currentPassword: String!, $password: String!, $language: Language!) {
  changePassword(
    currentPassword: $currentPassword
    password: $password
    language: $language
  ) {
    validationMessages {
      ...validationErrorFields
    }
  }
}
    ${ValidationErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    override document = ChangePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountryStatesDocument = gql`
    query CountryStates($country: CountryCode!) {
  countryStates(country: $country) {
    name
    isoCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountryStatesGQL extends Apollo.Query<CountryStatesQuery, CountryStatesQueryVariables> {
    override document = CountryStatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountryCodesDocument = gql`
    query CountryCodes {
  __type(name: "CountryCode") {
    name
    enumValues {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountryCodesGQL extends Apollo.Query<CountryCodesQuery, CountryCodesQueryVariables> {
    override document = CountryCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTicketDocument = gql`
    mutation CreateTicket($input: TicketAttributes!, $turnstileToken: String!) {
  createTicket(input: $input, turnstileToken: $turnstileToken) {
    __typename
    ... on Ticket {
      id
      title
    }
    ... on ValidationErrors {
      validationMessages {
        ...validationErrorFields
      }
    }
  }
}
    ${ValidationErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTicketGQL extends Apollo.Mutation<CreateTicketMutation, CreateTicketMutationVariables> {
    override document = CreateTicketDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserAttributes!, $language: Language) {
  createUser(input: $input, language: $language) {
    __typename
    ... on User {
      id
    }
    ... on ValidationErrors {
      validationMessages {
        ...validationErrorFields
      }
    }
  }
}
    ${ValidationErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    override document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAccountDocument = gql`
    mutation CreateAccount($parentClientNumber: Int, $managerUserIds: [ID!], $company: String!, $street: String!, $city: String!, $zip: String!, $country: CountryCode!, $countryState: String, $otherState: String, $phone: String!, $fax: String, $email: String!, $login: String!, $title: String, $firstname: String!, $lastname: String!, $cellPhone: String) {
  createAccount(
    parentClientNumber: $parentClientNumber
    managerUserIds: $managerUserIds
    company: $company
    street: $street
    city: $city
    zip: $zip
    country: $country
    countryStateCode: $countryState
    otherState: $otherState
    phone: $phone
    fax: $fax
    email: $email
    login: $login
    title: $title
    firstname: $firstname
    lastname: $lastname
    cellPhone: $cellPhone
  ) {
    __typename
    ... on Account {
      clientNumber
    }
    ... on ValidationErrors {
      validationMessages {
        ...validationErrorFields
      }
    }
  }
}
    ${ValidationErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAccountGQL extends Apollo.Mutation<CreateAccountMutation, CreateAccountMutationVariables> {
    override document = CreateAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentAccountDocument = gql`
    query CurrentAccount {
  currentAccount {
    branding {
      ...brandingFields
    }
  }
}
    ${BrandingFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentAccountGQL extends Apollo.Query<CurrentAccountQuery, CurrentAccountQueryVariables> {
    override document = CurrentAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    account {
      clientNumber
      company
    }
    allowedIpAddresses
    authorization {
      isAdmin
      permissions {
        subjectClass
        action
        requireTan
      }
      featureAccess
      brandProtectionAccess
    }
    cellPhone
    city
    clientNumber
    commercialRegisterNumber
    company
    country
    countryState
    email
    fax
    firstname
    id
    lastSignInAt
    lastname
    otherState
    phone
    settings {
      language
    }
    state
    street
    taxNumberCompany
    zip
    acceptDpa
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    override document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DomainExportFieldGroupsDocument = gql`
    query DomainExportFieldGroups {
  domainExportFieldGroups {
    label
    fields {
      label
      value
      default
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DomainExportFieldGroupsGQL extends Apollo.Query<DomainExportFieldGroupsQuery, DomainExportFieldGroupsQueryVariables> {
    override document = DomainExportFieldGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DomainExportDocument = gql`
    query DomainExport($ids: [ID!], $fields: [String!]!, $orderBy: DomainOrderBy, $filter: DomainFilterContainer) {
  domainExport(ids: $ids, fields: $fields, orderBy: $orderBy, filter: $filter)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DomainExportGQL extends Apollo.Query<DomainExportQuery, DomainExportQueryVariables> {
    override document = DomainExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DomainsDocument = gql`
    query Domains($after: String, $before: String, $first: Int, $last: Int, $orderBy: DomainOrderBy, $count: Boolean!, $filter: DomainFilterContainer) {
  domains(
    first: $first
    before: $before
    after: $after
    last: $last
    orderBy: $orderBy
    filter: $filter
  ) {
    edges {
      node {
        ...domainFields
      }
    }
    totalCount @include(if: $count)
  }
}
    ${DomainFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DomainsGQL extends Apollo.Query<DomainsQuery, DomainsQueryVariables> {
    override document = DomainsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogErrorDocument = gql`
    mutation LogError($uuid: String!, $route: String!, $message: String!, $name: String!, $stackTrace: String) {
  logError(
    uuid: $uuid
    route: $route
    message: $message
    name: $name
    stackTrace: $stackTrace
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogErrorGQL extends Apollo.Mutation<LogErrorMutation, LogErrorMutationVariables> {
    override document = LogErrorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogbookEntriesExportDocument = gql`
    query LogbookEntriesExport($ids: [ID!], $orderBy: LogbookEntryOrderBy) {
  logbookEntriesExport(ids: $ids, orderBy: $orderBy)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogbookEntriesExportGQL extends Apollo.Query<LogbookEntriesExportQuery, LogbookEntriesExportQueryVariables> {
    override document = LogbookEntriesExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LogbookEntriesDocument = gql`
    query LogbookEntries($after: String, $before: String, $first: Int, $last: Int, $orderBy: LogbookEntryOrderBy, $count: Boolean!) {
  logbookEntries(
    first: $first
    before: $before
    after: $after
    last: $last
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...logbookEntriesFields
      }
    }
    totalCount @include(if: $count)
  }
}
    ${LogbookEntriesFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LogbookEntriesGQL extends Apollo.Query<LogbookEntriesQuery, LogbookEntriesQueryVariables> {
    override document = LogbookEntriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OriginalUserDocument = gql`
    query OriginalUser {
  originalUser {
    ...originalUserFields
  }
}
    ${OriginalUserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OriginalUserGQL extends Apollo.Query<OriginalUserQuery, OriginalUserQueryVariables> {
    override document = OriginalUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionDataDocument = gql`
    query SessionData {
  sessionData {
    ...sessionDataFields
  }
}
    ${SessionDataFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionDataGQL extends Apollo.Query<SessionDataQuery, SessionDataQueryVariables> {
    override document = SessionDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserAttributes!, $language: Language) {
  updateUser(input: $input, language: $language) {
    __typename
    ... on User {
      id
    }
    ... on ValidationErrors {
      validationMessages {
        ...validationErrorFields
      }
    }
  }
}
    ${ValidationErrorFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    override document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($clientNumber: Int!, $company: String, $street: String, $city: String, $zip: String, $country: CountryCode, $countryState: String, $otherState: String, $phone: String, $fax: String, $passwordTtl: Int, $passwordMinLength: Int, $forceOriginalPassword: Boolean) {
  updateAccount(
    clientNumber: $clientNumber
    company: $company
    street: $street
    city: $city
    zip: $zip
    country: $country
    countryStateCode: $countryState
    otherState: $otherState
    phone: $phone
    fax: $fax
    passwordTtl: $passwordTtl
    passwordMinLength: $passwordMinLength
    forceOriginalPassword: $forceOriginalPassword
  ) {
    id
    clientNumber
    company
    street
    city
    zip
    country
    phone
    fax
    passwordTtl
    passwordMinLength
    forceOriginalPassword
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAccountGQL extends Apollo.Mutation<UpdateAccountMutation, UpdateAccountMutationVariables> {
    override document = UpdateAccountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserLanguageDocument = gql`
    mutation UpdateUserLanguage($language: String!) {
  updateUserSettings(input: {language: $language}) {
    user {
      id
      settings {
        language
      }
    }
    errors
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserLanguageGQL extends Apollo.Mutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables> {
    override document = UpdateUserLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserForUpdateDocument = gql`
    query UserForUpdate($id: ID!) {
  user(id: $id) {
    ...userForUpdateFields
  }
}
    ${UserForUpdateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserForUpdateGQL extends Apollo.Query<UserForUpdateQuery, UserForUpdateQueryVariables> {
    override document = UserForUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersExportDocument = gql`
    query UsersExport($ids: [ID!], $filter: UserFilterContainer) {
  usersExport(ids: $ids, filter: $filter)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersExportGQL extends Apollo.Query<UsersExportQuery, UsersExportQueryVariables> {
    override document = UsersExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersForAccountManagementDocument = gql`
    query UsersForAccountManagement($parentClientNumber: Int, $first: Int) {
  usersForAccountManagement(
    parentClientNumber: $parentClientNumber
    first: $first
  ) {
    nodes {
      ...usersForAccountManagementFields
    }
    totalCount
  }
}
    ${UsersForAccountManagementFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersForAccountManagementGQL extends Apollo.Query<UsersForAccountManagementQuery, UsersForAccountManagementQueryVariables> {
    override document = UsersForAccountManagementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersForImpersonationDocument = gql`
    query UsersForImpersonation($after: String, $before: String, $first: Int, $last: Int, $query: String!, $count: Boolean!) {
  usersForImpersonation(
    first: $first
    before: $before
    after: $after
    last: $last
    query: $query
  ) {
    nodes {
      ...usersForImpersonationFields
    }
    totalCount @include(if: $count)
  }
}
    ${UsersForImpersonationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersForImpersonationGQL extends Apollo.Query<UsersForImpersonationQuery, UsersForImpersonationQueryVariables> {
    override document = UsersForImpersonationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query Users($after: String, $before: String, $first: Int, $last: Int, $orderBy: UserOrderBy, $count: Boolean!, $filter: UserFilterContainer) {
  users(
    first: $first
    before: $before
    after: $after
    last: $last
    orderBy: $orderBy
    filter: $filter
  ) {
    edges {
      node {
        ...userFields
      }
    }
    totalCount @include(if: $count)
  }
}
    ${UserFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    override document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }